var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg50Meeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.50692923 -0.02334602 33.01385312 -0.04098757 49.52079487 -0.05181217 C57.18501143 -0.0569715 64.84921775 -0.06400731 72.51342773 -0.07543945 C79.19246829 -0.08539736 85.87150143 -0.09185607 92.55054921 -0.09408849 C96.08801803 -0.09539371 99.62546561 -0.0984677 103.16292763 -0.10573006 C107.10902941 -0.11376586 111.0551103 -0.11399042 115.0012207 -0.11352539 C116.17797867 -0.11712067 117.35473663 -0.12071594 118.56715393 -0.12442017 C120.17623627 -0.12235817 120.17623627 -0.12235817 121.81782532 -0.12025452 C122.75160161 -0.12117631 123.6853779 -0.1220981 124.64745045 -0.12304783 C127 0 127 0 130 1 C132.22147224 1.24214756 134.44791778 1.43950348 136.67578125 1.61328125 C138.06114532 1.72580183 139.44647935 1.83869263 140.83178711 1.9519043 C141.56219208 2.01050629 142.29259705 2.06910828 143.0451355 2.12948608 C156.79849703 3.23961044 170.43911557 4.70281645 184.08911133 6.72973633 C191.12043012 7.74453014 197.8957873 8.2346197 205 8 C205 8.66 205 9.32 205 10 C205.87845581 10.16435547 205.87845581 10.16435547 206.7746582 10.33203125 C219.09904158 12.67612968 231.214552 15.44516241 243.25 19 C244.34223877 19.3196875 245.43447754 19.639375 246.55981445 19.96875 C266.70402852 26.05604277 266.70402852 26.05604277 270 31 C269.01 31 268.02 31 267 31 C264.15628995 37.3079086 264.15628995 37.3079086 263 44 C263.81082031 44.22945312 264.62164063 44.45890625 265.45703125 44.6953125 C269.84538209 46.31130939 273.6684165 48.50449499 277.6875 50.875 C278.50750488 51.35388672 279.32750977 51.83277344 280.17236328 52.32617188 C287.89643813 56.87095578 295.4736352 61.64151904 303.0234375 66.46875 C303.71663086 66.90960938 304.40982422 67.35046875 305.12402344 67.8046875 C306.70393484 68.81135671 308.27839288 69.82657731 309.8515625 70.84375 C312.0336511 72.23695443 312.0336511 72.23695443 315 72 C315 72.99 315 73.98 315 75 C317.13990904 76.93597005 317.13990904 76.93597005 320 78.875 C321.11138131 79.67952739 322.22064823 80.48698122 323.328125 81.296875 C323.92431641 81.73193359 324.52050781 82.16699219 325.13476562 82.61523438 C337.18274423 91.55975461 348.22687073 101.57874213 359 112 C359.5352832 112.51336914 360.07056641 113.02673828 360.62207031 113.55566406 C366.48133094 119.18767477 371.82464822 125.02990904 376.88671875 131.38671875 C378.85193607 133.81690431 380.89264368 136.13063065 383 138.4375 C387.70507123 143.68188769 391.8613259 149.30510341 396 155 C396.41572266 155.56944336 396.83144531 156.13888672 397.25976562 156.72558594 C404.99035696 167.33608649 412.08715726 178.14908493 418.421875 189.6640625 C419.84931161 192.28814569 419.84931161 192.28814569 423 193 C422.67 193.66 422.34 194.32 422 195 C423.04109483 197.56269497 424.02610343 199.02610343 426 201 C426.71716621 202.38232283 427.38579731 203.79017758 428.0234375 205.2109375 C428.59578125 206.46003906 428.59578125 206.46003906 429.1796875 207.734375 C429.97230052 209.48537631 430.76140469 211.23797047 431.546875 212.9921875 C433.54395156 217.33482378 435.21422 220.90568667 439 224 C438.67 224.99 438.34 225.98 438 227 C439.17677967 230.10960684 439.17677967 230.10960684 440.875 233.4375 C442.59880727 236.96128277 444.15865724 240.170711 445 244 C445.5861332 245.67309384 446.19219798 247.33927108 446.8125 249 C448.33611967 253.15228218 449.82237163 257.31364492 451.25 261.5 C451.58515625 262.4796875 451.9203125 263.459375 452.265625 264.46875 C453 267 453 267 453 270 C453.66 270.33 454.32 270.66 455 271 C455.4140625 273.28515625 455.4140625 273.28515625 455.625 276.0625 C455.69976563 276.98160156 455.77453125 277.90070313 455.8515625 278.84765625 C455.90054688 279.55792969 455.94953125 280.26820313 456 281 C456.99 281 457.98 281 459 281 C458.82855469 281.56332031 458.65710938 282.12664062 458.48046875 282.70703125 C457.95707298 285.20486308 458.03227215 287.15708434 458.3125 289.6875 C458.43044922 290.86892578 458.43044922 290.86892578 458.55078125 292.07421875 C458.69902344 292.70972656 458.84726562 293.34523438 459 294 C459.66 294.33 460.32 294.66 461 295 C461.27463468 297.11617729 461.5356295 299.23503078 461.72705078 301.36035156 C462.00013883 304.00134265 462.42034499 306.56922496 462.90234375 309.1796875 C468.91890041 341.995425 468.24440315 374.75978639 468 408 C467.34 408 466.68 408 466 408 C466.01812744 408.65121826 466.03625488 409.30243652 466.05493164 409.97338867 C466.16728052 417.22342233 465.52335821 424.1500122 464.4375 431.3125 C464.26766602 432.45662354 464.09783203 433.60074707 463.92285156 434.77954102 C462.25229371 445.43473854 459.87086425 455.88678241 457.28686523 466.35083008 C456.99110596 467.55376709 456.69534668 468.7567041 456.390625 469.99609375 C456.12282227 471.06013428 455.85501953 472.1241748 455.57910156 473.22045898 C454.86402363 476.17944777 454.86402363 476.17944777 455 480 C454.34 480 453.68 480 453 480 C452.90783203 480.57468018 452.81566406 481.14936035 452.72070312 481.74145508 C451.41919719 489.04362645 449.11766067 495.76137639 446.5 502.6875 C446.06510254 503.85418213 445.63020508 505.02086426 445.18212891 506.22290039 C441.77830858 515.23405398 438.05112287 524.07929362 434.04882812 532.84057617 C433.64857422 533.72720947 433.24832031 534.61384277 432.8359375 535.52734375 C432.48063965 536.29812256 432.1253418 537.06890137 431.75927734 537.86303711 C430.77679898 540.25021859 430.77679898 540.25021859 431 544 C430.01 544 429.02 544 428 544 C427.65388672 545.18722656 427.65388672 545.18722656 427.30078125 546.3984375 C421.5175163 562.41096087 411.496482 576.99750442 402 591 C401.4937207 591.75249023 400.98744141 592.50498047 400.46582031 593.28027344 C395.22837639 601.05916556 389.9091657 608.71202897 384 616 C383.0231504 617.22503153 382.04661879 618.45031667 381.0703125 619.67578125 C375.08538239 627.1515682 368.95448384 634.39974457 362.41796875 641.3984375 C360.3701333 643.60176288 358.39123109 645.83881583 356.4375 648.125 C352.87580626 652.25864456 348.96875836 656.0194878 345.0390625 659.80078125 C342.79972467 661.91229248 342.79972467 661.91229248 342 665 C341.13375 665.185625 341.13375 665.185625 340.25 665.375 C336.92577245 666.29839654 335.38673536 668.54072999 333 671 C325.30820394 678.35936374 317.31126274 685.13363517 308.85058594 691.58642578 C306.97912368 693.01594642 305.11850103 694.45883914 303.2578125 695.90234375 C273.68020813 718.663308 240.95296172 736.00126707 206.125 749.25 C204.90103516 749.71607666 203.67707031 750.18215332 202.41601562 750.66235352 C193.74670628 753.8865121 193.74670628 753.8865121 189.69091797 754.50292969 C188.35891357 754.74897949 188.35891357 754.74897949 187 755 C186.67 755.66 186.34 756.32 186 757 C184.20483398 757.51416016 184.20483398 757.51416016 181.80859375 757.9140625 C177.6344794 758.67326146 173.52952236 759.56929337 169.41015625 760.5859375 C123.60638025 771.7879649 77.12766126 774.92213548 30.26171875 769.75390625 C21.11961455 768.74680005 11.76695127 767.79029268 2.5625 768.125 C-1 768 -1 768 -3 766 C-2.67 765.67 -2.34 765.34 -2 765 C-2.99 764.67 -3.98 764.34 -5 764 C-5.33 765.32 -5.66 766.64 -6 768 C-6.33 766.68 -6.66 765.36 -7 764 C-9.66419818 763.32184046 -12.33065758 762.65734223 -15 762 C-15.74378906 761.80921875 -16.48757813 761.6184375 -17.25390625 761.421875 C-21.06409326 760.49417729 -24.44486077 759.9113408 -28.375 760.0625 C-32 760 -32 760 -33.53125 758.66796875 C-34.25828125 757.84232422 -34.25828125 757.84232422 -35 757 C-37.5044529 755.99878291 -39.93628631 755.12068022 -42.5 754.3125 C-43.17675781 754.08755859 -43.85351562 753.86261719 -44.55078125 753.63085938 C-47.47985337 752.68049968 -49.90184951 752 -53 752 C-53 751.34 -53 750.68 -53 750 C-53.79792969 749.91363281 -54.59585937 749.82726562 -55.41796875 749.73828125 C-60.01475379 748.79085227 -64.02572859 747.06690403 -68.3125 745.1875 C-69.21967773 744.79296631 -70.12685547 744.39843262 -71.06152344 743.99194336 C-103.0344777 729.94346744 -103.0344777 729.94346744 -116.61230469 720.85766602 C-120.07054445 718.65075109 -121.79957168 717.98794267 -125.9609375 718.23828125 C-126.96382812 718.48964844 -127.96671875 718.74101563 -129 719 C-128.75830078 717.94039062 -128.75830078 717.94039062 -128.51171875 716.859375 C-129.09606623 713.43743616 -129.68829133 713.13476812 -132.39453125 711.140625 C-133.85554781 710.1595238 -135.32887279 709.19656182 -136.8125 708.25 C-137.55048828 707.75628906 -138.28847656 707.26257813 -139.04882812 706.75390625 C-142.03696139 704.77984536 -144.58533051 703.13822316 -148 702 C-149.68080217 700.34758976 -151.34540141 698.67864799 -153 697 C-154.97552636 695.4270945 -156.97739946 693.8868939 -159 692.375 C-164.45063888 688.26233855 -169.69432644 683.9547949 -174.86132812 679.49169922 C-177.74646003 676.9799756 -177.74646003 676.9799756 -181 675 C-181 674.34 -181 673.68 -181 673 C-181.88860718 672.60035034 -181.88860718 672.60035034 -182.79516602 672.19262695 C-185.04520525 670.97554782 -186.49331612 669.73700372 -188.27734375 667.91796875 C-188.87353516 667.31533203 -189.46972656 666.71269531 -190.08398438 666.09179688 C-191.00147461 665.14916992 -191.00147461 665.14916992 -191.9375 664.1875 C-192.54529297 663.57068359 -193.15308594 662.95386719 -193.77929688 662.31835938 C-194.97027057 661.10939902 -196.15937261 659.89859152 -197.34643555 658.68579102 C-199.54835314 656.44095993 -201.77252893 654.21945859 -204 652 C-205 651 -206 650 -207 649 C-207.66 649.33 -208.32 649.66 -209 650 C-209.185625 649.319375 -209.37125 648.63875 -209.5625 647.9375 C-211.2251064 644.53999997 -213.23904805 642.66257542 -215.9453125 640.07421875 C-220.81547398 635.15776296 -225.00829646 629.56669969 -229.24609375 624.10546875 C-229.94863281 623.20441406 -230.65117187 622.30335938 -231.375 621.375 C-232.00148438 620.55773437 -232.62796875 619.74046875 -233.2734375 618.8984375 C-234.94886693 616.74533749 -234.94886693 616.74533749 -238 616 C-238.33333333 614.66666667 -238.66666667 613.33333333 -239 612 C-241.46162334 608.27857269 -241.46162334 608.27857269 -245.25 606.1875 C-245.8275 606.125625 -246.405 606.06375 -247 606 C-246.69328369 605.11489746 -246.69328369 605.11489746 -246.38037109 604.21191406 C-245.82525949 600.98385812 -247.43599226 599.30413811 -249.21484375 596.71899414 C-249.68019531 596.06922607 -250.14554687 595.41945801 -250.625 594.75 C-251.55568273 593.41084736 -252.4853798 592.07100915 -253.4140625 590.73046875 C-253.86297852 590.08899902 -254.31189453 589.4475293 -254.77441406 588.78662109 C-256.27565155 586.59816374 -257.647527 584.34531048 -259 582.0625 C-259.66 581.051875 -260.32 580.04125 -261 579 C-261.66 579 -262.32 579 -263 579 C-263.103125 578.278125 -263.20625 577.55625 -263.3125 576.8125 C-264.6712266 571.25407302 -267.44114673 568.32673076 -272 565 C-271.67 564.01 -271.34 563.02 -271 562 C-271.75187857 559.96566961 -271.75187857 559.96566961 -272.9375 557.9375 C-275 554.18305085 -275 554.18305085 -275 552 C-276.32 551.67 -277.64 551.34 -279 551 C-278.67 550.01 -278.34 549.02 -278 548 C-278.98072151 545.50676898 -278.98072151 545.50676898 -280.4375 542.9375 C-283 538.18256131 -283 538.18256131 -283 536 C-283.66 535.67 -284.32 535.34 -285 535 C-286.02077893 532.77830468 -286.85171964 530.63266288 -287.41015625 528.25 C-288.21119182 525.19439413 -289.28019014 522.27512185 -290.375 519.3125 C-290.79523438 518.15363281 -291.21546875 516.99476563 -291.6484375 515.80078125 C-292.09445312 514.87652344 -292.54046875 513.95226562 -293 513 C-293.99 512.67 -294.98 512.34 -296 512 C-297 509 -297 509 -296.41015625 506.8515625 C-295.80832225 502.66738327 -297.14180677 499.33988894 -298.4375 495.375 C-301 487.32725464 -301 487.32725464 -301 484 C-301.66 483.67 -302.32 483.34 -303 483 C-303.54272461 480.91357422 -303.54272461 480.91357422 -303.96484375 478.1796875 C-304.63267093 474.13616693 -305.37195437 470.1353629 -306.25390625 466.1328125 C-310.52509254 446.55025061 -310.52509254 446.55025061 -310.76171875 437.09765625 C-310.84035156 436.40542969 -310.91898437 435.71320313 -311 435 C-311.66 434.67 -312.32 434.34 -313 434 C-313.06058594 432.84886719 -313.12117188 431.69773437 -313.18359375 430.51171875 C-313.24365601 429.37307373 -313.24365601 429.37307373 -313.30493164 428.21142578 C-313.39467641 426.50280432 -313.48368494 424.79414406 -313.57202148 423.08544922 C-313.79431259 418.80448971 -314.02518333 414.52470609 -314.2890625 410.24609375 C-317.75762632 352.92383187 -309.93098628 293.72702567 -287.46875 240.62109375 C-285.87471082 237.34237998 -285.87471082 237.34237998 -286 235 C-287.485 234.01 -287.485 234.01 -289 233 C-287.35 232.67 -285.7 232.34 -284 232 C-283.01 229.03 -282.02 226.06 -281 223 C-280.34 223 -279.68 223 -279 223 C-278.7525 222.195625 -278.505 221.39125 -278.25 220.5625 C-274.0212766 208.5106383 -274.0212766 208.5106383 -271 207 C-270.32812276 205.00174441 -269.66240683 203.00141491 -269 201 C-267.8925096 199.00760306 -266.72025313 197.0503994 -265.5 195.125 C-264.77599077 193.97659458 -264.05203486 192.82815556 -263.328125 191.6796875 C-262.94720703 191.07995117 -262.56628906 190.48021484 -262.17382812 189.86230469 C-260.98946589 187.98328739 -259.82808376 186.0917651 -258.671875 184.1953125 C-250.57826649 170.96997668 -241.90393577 158.17695636 -231.90234375 146.3125 C-230.18694121 144.2272468 -228.64131653 142.10672996 -227.125 139.875 C-225 137 -225 137 -222 136 C-221.29008249 134.68918371 -220.62758857 133.35216671 -220 132 C-218.6340332 130.31518555 -218.6340332 130.31518555 -217.05078125 128.63671875 C-216.45749023 128.00451416 -215.86419922 127.37230957 -215.25292969 126.72094727 C-214.61258789 126.04990967 -213.97224609 125.37887207 -213.3125 124.6875 C-212.64766602 123.98616943 -211.98283203 123.28483887 -211.29785156 122.56225586 C-191.92048287 102.21145935 -191.92048287 102.21145935 -181.52734375 94.03125 C-178.99232606 91.99383238 -176.6278535 89.84276812 -174.25 87.625 C-169.47186254 83.23990288 -164.32781978 79.48868657 -159.00097656 75.80517578 C-155.35954584 73.29988037 -155.35954584 73.29988037 -152.875 69.73828125 C-152.441875 68.87783203 -152.441875 68.87783203 -152 68 C-151.30777344 67.86207031 -150.61554688 67.72414063 -149.90234375 67.58203125 C-145.49110932 66.69740954 -142.27461454 64.15327006 -138.5625 61.6875 C-128.03318237 54.84808591 -117.08653747 48.87963022 -106 43 C-106.33 41.68 -106.66 40.36 -107 39 C-107.66 39 -108.32 39 -109 39 C-108.67 38.01 -108.34 37.02 -108 36 C-109.41488448 33.23760649 -110.80363095 31.19636905 -113 29 C-113 27.68 -113 26.36 -113 25 C-110.76962261 24.4384323 -108.53717265 23.88881427 -106.30078125 23.3515625 C-100.73586525 21.9985241 -95.31225133 20.53577464 -89.9375 18.55078125 C-88 18 -88 18 -84 18 C-83.67 17.34 -83.34 16.68 -83 16 C-81.12890625 15.5078125 -81.12890625 15.5078125 -78.5625 15.125 C-72.40180108 14.12115418 -66.35488077 12.757789 -60.28344727 11.32080078 C-56.44640393 10.4384436 -52.96848671 9.76283944 -49 10 C-48.67 9.34 -48.34 8.68 -48 8 C-45.51243288 7.56118694 -43.10651637 7.24957743 -40.59765625 7.0078125 C-39.03791336 6.84156343 -37.47818063 6.67521899 -35.91845703 6.50878906 C-35.10693176 6.42552368 -34.29540649 6.3422583 -33.45928955 6.25646973 C-29.53030063 5.84673078 -25.60747277 5.38533039 -21.68359375 4.9296875 C-20.14392572 4.7535081 -18.6042121 4.57772661 -17.06445312 4.40234375 C-16.30527588 4.31581543 -15.54609863 4.22928711 -14.76391602 4.14013672 C-13.99619873 4.0526416 -13.22848145 3.96514648 -12.4375 3.875 C-10.82877296 3.69143325 -9.22004899 3.5078396 -7.61132812 3.32421875 C-3.74092049 2.88250446 0.12952769 2.44114716 4 2 C2.35 2 0.7 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z M289 168 C289.66 169.32 290.32 170.64 291 172 C291 170.68 291 169.36 291 168 C290.34 168 289.68 168 289 168 Z M288 172 C287.85304688 172.64066406 287.70609375 173.28132812 287.5546875 173.94140625 C285.94901813 180.1333841 284.06544566 184.90615922 279 189 C276.08693049 190.61331454 273.10337543 191.80943234 270 193 C268.65937705 193.65188367 267.32361287 194.31423677 266 195 C266.72445312 195.24234375 267.44890625 195.4846875 268.1953125 195.734375 C276.55971313 198.63403389 282.41501635 201.24079689 287 209 C290.05291694 209 292.15603665 208.97225073 295 208 C296.6549414 206.1703946 297.87584627 204.21456914 299.21484375 202.14453125 C302.54995142 198.13802335 307.35183202 196.18348104 312 194 C309.24775672 191.98110396 309.24775672 191.98110396 306.8125 191.25 C301.77085238 189.00926773 296.89553636 186.26240763 294.8125 181 C294.544375 180.01 294.27625 179.02 294 178 C292.4820641 175.79849032 290.82881598 173.96949413 289 172 C288.67 172 288.34 172 288 172 Z M291 173 C292 175 292 175 292 175 Z M288 209 C288.33 210.65 288.66 212.3 289 214 C289.268125 213.360625 289.53625 212.72125 289.8125 212.0625 C291 210 291 210 294 209 C292.02 209 290.04 209 288 209 Z M292 211 C291.67 211.66 291.34 212.32 291 213 C291.66 213 292.32 213 293 213 C292.67 212.34 292.34 211.68 292 211 Z M290 214 C290.33 214.66 290.66 215.32 291 216 C291.33 215.34 291.66 214.68 292 214 C291.34 214 290.68 214 290 214 Z M436 223 C437 225 437 225 437 225 Z M-180 555 C-180.31453125 555.68707031 -180.6290625 556.37414062 -180.953125 557.08203125 C-181.38109375 557.98308594 -181.8090625 558.88414062 -182.25 559.8125 C-182.87648437 561.15248047 -182.87648437 561.15248047 -183.515625 562.51953125 C-185.07226426 565.12075739 -186.56520705 566.26755117 -189 568 C-189 568.66 -189 569.32 -189 570 C-188.071875 570.598125 -187.14375 571.19625 -186.1875 571.8125 C-182.94425561 574.03825595 -181.92894931 575.69322976 -180 579 C-179.01 579 -178.02 579 -177 579 C-175.65668346 577.00669158 -174.32405988 575.00615134 -173 573 C-170.75 571.625 -170.75 571.625 -169 571 C-169 570.34 -169 569.68 -169 569 C-170.1446875 568.1028125 -170.1446875 568.1028125 -171.3125 567.1875 C-174.04250175 564.96540555 -175.2846608 563.0222643 -177 560 C-177.66 559.67 -178.32 559.34 -179 559 C-178.67 558.34 -178.34 557.68 -178 557 C-178.66 556.34 -179.32 555.68 -180 555 Z M-270 564 C-269 566 -269 566 -269 566 Z M-3 656 C-4.37651696 657.84261655 -4.37651696 657.84261655 -5.625 660.1875 C-8.83344852 665.32425849 -12.54273141 667.58667456 -18 670 C-15.00839325 672.0892136 -15.00839325 672.0892136 -11.5625 673.6875 C-7.4415458 675.98370965 -6.01462901 678.80957165 -4 683 C-3.01 683 -2.02 683 -1 683 C0.33108858 681.36419432 0.33108858 681.36419432 1.4375 679.25 C5.07583449 673.1501217 5.07583449 673.1501217 8 671 C11.75 670.25 11.75 670.25 15 670 C12.6097371 668.08778968 10.16522463 666.49023313 7.5 665 C1.89144737 661.81578947 1.89144737 661.81578947 0 660 C0 658.68 0 657.36 0 656 C-0.99 656 -1.98 656 -3 656 Z M76 660 C77 662 77 662 77 662 Z M75 664 C74.773125 664.515625 74.54625 665.03125 74.3125 665.5625 C69.44801137 674.59655032 63.65836925 678.66952784 54 682 C56.88935265 684.17216516 56.88935265 684.17216516 60.3125 684.8125 C65.46194215 686.47079493 68.88801053 688.96135263 71.5 693.75 C72.86737844 696.34483802 72.86737844 696.34483802 76.1875 696.8125 C77.5796875 696.9053125 77.5796875 696.9053125 79 697 C79.23332031 696.48050781 79.46664063 695.96101562 79.70703125 695.42578125 C83.28675081 688.58257178 88.00601082 686.68919405 95 684 C96.3417365 683.35041138 97.67869011 682.69019011 99 682 C98.35933594 681.85304688 97.71867187 681.70609375 97.05859375 681.5546875 C90.87270316 679.95059665 86.08324426 678.06885495 82 673 C80.39471917 670.08477191 79.12033806 667.13137967 78 664 C77.01 664 76.02 664 75 664 Z M-3 684 C-2 687 -2 687 -2 687 Z ",
    fill: "#23BB70",
    transform: "translate(433,136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.50692923 -0.02334602 33.01385312 -0.04098757 49.52079487 -0.05181217 C57.18501143 -0.0569715 64.84921775 -0.06400731 72.51342773 -0.07543945 C79.19246829 -0.08539736 85.87150143 -0.09185607 92.55054921 -0.09408849 C96.08801803 -0.09539371 99.62546561 -0.0984677 103.16292763 -0.10573006 C107.10902941 -0.11376586 111.0551103 -0.11399042 115.0012207 -0.11352539 C116.17797867 -0.11712067 117.35473663 -0.12071594 118.56715393 -0.12442017 C120.17623627 -0.12235817 120.17623627 -0.12235817 121.81782532 -0.12025452 C122.75160161 -0.12117631 123.6853779 -0.1220981 124.64745045 -0.12304783 C127 0 127 0 130 1 C132.22147224 1.24214756 134.44791778 1.43950348 136.67578125 1.61328125 C138.06114532 1.72580183 139.44647935 1.83869263 140.83178711 1.9519043 C141.56219208 2.01050629 142.29259705 2.06910828 143.0451355 2.12948608 C156.79849703 3.23961044 170.43911557 4.70281645 184.08911133 6.72973633 C191.12043012 7.74453014 197.8957873 8.2346197 205 8 C205 8.66 205 9.32 205 10 C205.87845581 10.16435547 205.87845581 10.16435547 206.7746582 10.33203125 C219.09904158 12.67612968 231.214552 15.44516241 243.25 19 C244.34223877 19.3196875 245.43447754 19.639375 246.55981445 19.96875 C266.70402852 26.05604277 266.70402852 26.05604277 270 31 C269.01 31 268.02 31 267 31 C266.731875 31.70125 266.46375 32.4025 266.1875 33.125 C264.29592496 37.70460272 262.14540275 41.84595719 259.328125 45.91796875 C255.5161503 51.59916673 252.27539039 57.56114511 249 63.5625 C247.67158827 65.97986976 246.33876965 68.39478121 245.00390625 70.80859375 C244.66855362 71.41505737 244.33320099 72.021521 243.98768616 72.6463623 C240.7267519 78.52493567 237.34586013 84.33078778 233.9375 90.125 C229.10646454 98.34103741 224.38771606 106.61079191 219.75 114.9375 C215.62164063 122.33455065 211.49215067 129.72993157 207.25 137.0625 C206.84362305 137.77720459 206.43724609 138.49190918 206.01855469 139.22827148 C205.06958793 140.85363381 204.04301234 142.4333265 203 144 C202.34 144 201.68 144 201 144 C201 144.66 201 145.32 201 146 C201.680625 146.185625 202.36125 146.37125 203.0625 146.5625 C209.97724777 149.94631274 213.84449412 155.35847011 216.33984375 162.53125 C218.41793759 170.30258318 216.56120203 176.94081255 213 184 C208.44079187 190.40178965 201.99033901 193.98164814 194.35717773 195.53930664 C190.54545431 196.06237566 186.8140921 196.12544558 182.9765625 196.09765625 C182.23038666 196.0962413 181.48421082 196.09482635 180.71542358 196.09336853 C178.35190682 196.08780874 175.98848773 196.07526389 173.625 196.0625 C172.01432429 196.0574798 170.40364709 196.0529178 168.79296875 196.04882812 C164.86194201 196.03785251 160.93098752 196.02061596 157 196 C158.12792969 196.44988281 159.25585938 196.89976562 160.41796875 197.36328125 C184.78697805 207.2508253 206.26168663 219.62588573 226 237 C226.67804688 237.5671875 227.35609375 238.134375 228.0546875 238.71875 C239.5136236 248.35802672 249.8561178 259.26132448 258.74121094 271.30126953 C259.96672711 272.95509838 261.21896464 274.58534344 262.4765625 276.21484375 C282.73687311 302.95684739 295.85042232 335.97422084 301 369 C301.11714355 369.74233887 301.23428711 370.48467773 301.35498047 371.24951172 C309.63167874 427.04651031 296.90187929 488.27707086 263.44091797 534.05810547 C262.96541504 534.69893066 262.48991211 535.33975586 262 536 C261.53352051 536.63180176 261.06704102 537.26360352 260.58642578 537.91455078 C241.48756085 563.52454432 217.62657946 585.16246277 189.83105469 600.95898438 C188.08035798 601.95431381 186.34065444 602.96890522 184.6015625 603.984375 C159.69794488 617.97517142 132.16925177 626.05914067 104 630 C103.25935303 630.1038501 102.51870605 630.2077002 101.75561523 630.31469727 C93.0288705 631.35687865 84.2141269 631.2870478 75.4375 631.3125 C74.57372742 631.31511841 73.70995483 631.31773682 72.82000732 631.32043457 C58.21169609 631.32516491 44.30264463 630.11510231 30 627 C28.44665438 626.6846997 26.89327108 626.36958497 25.33984375 626.0546875 C8.48198231 622.48696612 -7.50468894 616.46352721 -23 609 C-23.82902832 608.60184082 -24.65805664 608.20368164 -25.51220703 607.79345703 C-44.23699617 598.68037268 -61.06883844 587.25917096 -76.53173828 573.31689453 C-77.87890913 572.10860728 -79.24898446 570.92598505 -80.62109375 569.74609375 C-92.09337482 559.77897596 -102.16449602 548.34520255 -111 536 C-111.40283203 535.43764648 -111.80566406 534.87529297 -112.22070312 534.29589844 C-130.07014239 509.07755438 -142.05100554 481.06359295 -148.25 450.8125 C-148.40114258 450.07837891 -148.55228516 449.34425781 -148.70800781 448.58789062 C-151.40916956 434.50282597 -152.41056023 420.44053245 -152.375 406.125 C-152.37478851 405.32862122 -152.37457703 404.53224243 -152.37435913 403.71173096 C-152.33536428 388.8659649 -151.01711239 374.56855676 -148 360 C-147.82339844 359.14390137 -147.64679688 358.28780273 -147.46484375 357.40576172 C-139.22670384 319.273853 -119.70694233 283.88434552 -93.2578125 255.4453125 C-91.31501563 253.34117609 -89.46383928 251.19417054 -87.625 249 C-66.42530582 224.72932209 -36.55997478 207.73222946 -7 196 C-8.56512329 196.02356567 -8.56512329 196.02356567 -10.16186523 196.04760742 C-14.0699884 196.10231722 -17.97807839 196.13649782 -21.88647461 196.16479492 C-23.57110302 196.17978874 -25.25569303 196.20019073 -26.94018555 196.22631836 C-48.50580714 196.55219886 -48.50580714 196.55219886 -58 189 C-63.58383331 183.15645351 -66.12211363 178.16396644 -66.5 170.1875 C-66.2651037 162.66142251 -63.98785638 157.11867321 -58.76953125 151.671875 C-55.65032533 148.84270943 -52.50425561 146.33617041 -49 144 C-49.29656494 143.49774902 -49.59312988 142.99549805 -49.89868164 142.47802734 C-55.26051717 133.37318025 -60.46324858 124.28296585 -65.09765625 114.78515625 C-67.38796797 110.15850264 -69.88810464 105.6480846 -72.375 101.125 C-77.54819237 91.71320811 -82.60176555 82.24227622 -87.625 72.75 C-93.61971987 61.42559043 -99.69421207 50.15520223 -106 39 C-106.99 39 -107.98 39 -109 39 C-108.67 38.01 -108.34 37.02 -108 36 C-109.41488448 33.23760649 -110.80363095 31.19636905 -113 29 C-113 27.68 -113 26.36 -113 25 C-110.76962261 24.4384323 -108.53717265 23.88881427 -106.30078125 23.3515625 C-100.73586525 21.9985241 -95.31225133 20.53577464 -89.9375 18.55078125 C-88 18 -88 18 -84 18 C-83.67 17.34 -83.34 16.68 -83 16 C-81.12890625 15.5078125 -81.12890625 15.5078125 -78.5625 15.125 C-72.40180108 14.12115418 -66.35488077 12.757789 -60.28344727 11.32080078 C-56.44640393 10.4384436 -52.96848671 9.76283944 -49 10 C-48.67 9.34 -48.34 8.68 -48 8 C-45.51243288 7.56118694 -43.10651637 7.24957743 -40.59765625 7.0078125 C-39.03791336 6.84156343 -37.47818063 6.67521899 -35.91845703 6.50878906 C-34.70116913 6.38389099 -34.70116913 6.38389099 -33.45928955 6.25646973 C-29.53030063 5.84673078 -25.60747277 5.38533039 -21.68359375 4.9296875 C-20.14392572 4.7535081 -18.6042121 4.57772661 -17.06445312 4.40234375 C-16.30527588 4.31581543 -15.54609863 4.22928711 -14.76391602 4.14013672 C-13.99619873 4.0526416 -13.22848145 3.96514648 -12.4375 3.875 C-10.82877296 3.69143325 -9.22004899 3.5078396 -7.61132812 3.32421875 C-3.74092049 2.88250446 0.12952769 2.44114716 4 2 C2.35 2 0.7 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#FCCF28",
    transform: "translate(433,136)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.80050781 0.19335938 1.60101562 0.38671875 2.42578125 0.5859375 C45.81261352 11.25159278 82.09104015 36.62906299 106.12890625 74.33984375 C127.03799078 109.40654716 132.54066814 151.65279272 123.00390625 191.265625 C112.73105309 230.70160921 86.98498477 268.29856175 51.6875 289.125 C48.80776474 290.77984284 45.90763781 292.3948182 43 294 C42.34660645 294.36899414 41.69321289 294.73798828 41.02001953 295.11816406 C30.68409072 300.90964462 20.13111241 304.52400672 8.63964844 307.35058594 C6.9540803 307.76527436 5.27191243 308.19421581 3.59472656 308.64160156 C-18.75559375 314.53506254 -46.6157841 314.86471857 -69 309 C-70.11592529 308.72591309 -70.11592529 308.72591309 -71.25439453 308.44628906 C-91.24709589 303.43886355 -111.34386314 295.25086137 -128 283 C-128.5455957 282.60941406 -129.09119141 282.21882813 -129.65332031 281.81640625 C-163.43237008 257.49704437 -187.39045549 220.45241346 -194.62597656 179.36499023 C-201.22014117 137.66938152 -191.83325713 97.0589324 -167.39428711 62.77246094 C-164.10584836 58.29039362 -160.65238067 54.19097825 -156.5234375 50.4453125 C-154.75819102 48.87761762 -154.75819102 48.87761762 -153 46 C-152.34 46 -151.68 46 -151 46 C-151 45.34 -151 44.68 -151 44 C-150.34 44 -149.68 44 -149 44 C-148.67 43.01 -148.34 42.02 -148 41 C-145.8125 38.984375 -145.8125 38.984375 -143 36.75 C-141.99453125 35.95078125 -140.9890625 35.1515625 -139.953125 34.328125 C-138.97859375 33.55984375 -138.0040625 32.7915625 -137 32 C-135.90945313 31.09507812 -135.90945313 31.09507812 -134.796875 30.171875 C-99.076846 0.99597345 -44.74234288 -11.37098217 0 0 Z ",
    fill: "#FDC325",
    transform: "translate(543,389)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.50692923 -0.02334602 33.01385312 -0.04098757 49.52079487 -0.05181217 C57.18501143 -0.0569715 64.84921775 -0.06400731 72.51342773 -0.07543945 C79.19246829 -0.08539736 85.87150143 -0.09185607 92.55054921 -0.09408849 C96.08801803 -0.09539371 99.62546561 -0.0984677 103.16292763 -0.10573006 C107.10902941 -0.11376586 111.0551103 -0.11399042 115.0012207 -0.11352539 C116.17797867 -0.11712067 117.35473663 -0.12071594 118.56715393 -0.12442017 C120.17623627 -0.12235817 120.17623627 -0.12235817 121.81782532 -0.12025452 C122.75160161 -0.12117631 123.6853779 -0.1220981 124.64745045 -0.12304783 C127 0 127 0 130 1 C132.22147224 1.24214756 134.44791778 1.43950348 136.67578125 1.61328125 C138.06114532 1.72580183 139.44647935 1.83869263 140.83178711 1.9519043 C141.56219208 2.01050629 142.29259705 2.06910828 143.0451355 2.12948608 C156.79849703 3.23961044 170.43911557 4.70281645 184.08911133 6.72973633 C191.12043012 7.74453014 197.8957873 8.2346197 205 8 C205 8.66 205 9.32 205 10 C205.87845581 10.16435547 205.87845581 10.16435547 206.7746582 10.33203125 C219.09904158 12.67612968 231.214552 15.44516241 243.25 19 C244.34223877 19.3196875 245.43447754 19.639375 246.55981445 19.96875 C266.70402852 26.05604277 266.70402852 26.05604277 270 31 C269.01 31 268.02 31 267 31 C266.731875 31.70125 266.46375 32.4025 266.1875 33.125 C264.29592496 37.70460272 262.14540275 41.84595719 259.328125 45.91796875 C255.5161503 51.59916673 252.27539039 57.56114511 249 63.5625 C247.67158827 65.97986976 246.33876965 68.39478121 245.00390625 70.80859375 C244.66855362 71.41505737 244.33320099 72.021521 243.98768616 72.6463623 C240.7267519 78.52493567 237.34586013 84.33078778 233.9375 90.125 C229.10644122 98.34107708 224.38938232 106.61169638 219.75 114.9375 C218.58876496 117.00923975 217.42731234 119.08085757 216.265625 121.15234375 C214.18778215 124.8602604 212.13805389 128.58140808 210.109375 132.31640625 C209.24040564 133.87806202 208.37067012 135.43929182 207.5 137 C207.12713867 137.70632568 206.75427734 138.41265137 206.37011719 139.14038086 C205.28125 141.0625 205.28125 141.0625 203 144 C197.79690574 145.38518313 192.36469242 145.17480236 187.01338196 145.21014404 C186.01146275 145.22032067 185.00954355 145.23049729 183.97726315 145.24098229 C180.62199267 145.27339197 177.26671223 145.29850802 173.91137695 145.32324219 C171.50472373 145.34420397 169.09807194 145.36533132 166.69142151 145.38661194 C144.74603684 145.57042447 122.79996526 145.63896456 100.85389423 145.67541122 C97.91895291 145.68058732 94.98401242 145.68609592 92.04907227 145.69189453 C90.95495305 145.6940362 90.95495305 145.6940362 89.83873042 145.69622114 C78.02499425 145.72136811 66.21282899 145.81648058 54.39973734 145.93823323 C42.25730053 146.06192289 30.11612361 146.11335269 17.9730584 146.09738469 C10.49001219 146.08973785 3.01159745 146.13731103 -4.47051827 146.25667092 C-10.21175477 146.34213596 -15.94935435 146.3264813 -21.69082069 146.27374077 C-24.03907791 146.26776606 -26.38768144 146.2941288 -28.73513794 146.35573769 C-45.99448373 146.78222555 -45.99448373 146.78222555 -51.01242852 142.1370821 C-54.54944504 137.58611074 -56.93749097 132.62297207 -59.07403243 127.29363298 C-60.34294389 124.15052381 -61.8787469 121.19624012 -63.4375 118.1875 C-64.25927734 116.50333984 -64.25927734 116.50333984 -65.09765625 114.78515625 C-67.38796797 110.15850264 -69.88810464 105.6480846 -72.375 101.125 C-77.54819237 91.71320811 -82.60176555 82.24227622 -87.625 72.75 C-93.61971987 61.42559043 -99.69421207 50.15520223 -106 39 C-106.99 39 -107.98 39 -109 39 C-108.67 38.01 -108.34 37.02 -108 36 C-109.41488448 33.23760649 -110.80363095 31.19636905 -113 29 C-113 27.68 -113 26.36 -113 25 C-110.76962261 24.4384323 -108.53717265 23.88881427 -106.30078125 23.3515625 C-100.73586525 21.9985241 -95.31225133 20.53577464 -89.9375 18.55078125 C-88 18 -88 18 -84 18 C-83.67 17.34 -83.34 16.68 -83 16 C-81.12890625 15.5078125 -81.12890625 15.5078125 -78.5625 15.125 C-72.40180108 14.12115418 -66.35488077 12.757789 -60.28344727 11.32080078 C-56.44640393 10.4384436 -52.96848671 9.76283944 -49 10 C-48.67 9.34 -48.34 8.68 -48 8 C-45.51243288 7.56118694 -43.10651637 7.24957743 -40.59765625 7.0078125 C-39.03791336 6.84156343 -37.47818063 6.67521899 -35.91845703 6.50878906 C-34.70116913 6.38389099 -34.70116913 6.38389099 -33.45928955 6.25646973 C-29.53030063 5.84673078 -25.60747277 5.38533039 -21.68359375 4.9296875 C-20.14392572 4.7535081 -18.6042121 4.57772661 -17.06445312 4.40234375 C-16.30527588 4.31581543 -15.54609863 4.22928711 -14.76391602 4.14013672 C-13.99619873 4.0526416 -13.22848145 3.96514648 -12.4375 3.875 C-10.82877296 3.69143325 -9.22004899 3.5078396 -7.61132812 3.32421875 C-3.74092049 2.88250446 0.12952769 2.44114716 4 2 C2.35 2 0.7 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#EA5230",
    transform: "translate(433,136)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.48946885 20.46504909 41.44687411 45.09498521 52.01171875 74.5390625 C52.24439453 75.17021973 52.47707031 75.80137695 52.71679688 76.45166016 C57.08532716 88.48378736 59.06224654 100.92572411 61.01171875 113.5390625 C61.305625 115.26576172 61.305625 115.26576172 61.60546875 117.02734375 C63.47356889 133.17563246 62.10143817 149.64155825 59.01171875 165.5390625 C58.7782373 166.74344971 58.7782373 166.74344971 58.54003906 167.97216797 C48.54206376 217.15382491 18.85233112 259.65215987 -22.36328125 287.7265625 C-38.38004833 298.31946511 -56.11781981 305.3210755 -74.61328125 310.2890625 C-75.64835815 310.56882935 -75.64835815 310.56882935 -76.7043457 310.85424805 C-79.12298226 311.47058975 -81.54786866 312.01482572 -83.98828125 312.5390625 C-85.20346436 312.80017822 -86.41864746 313.06129395 -87.6706543 313.33032227 C-98.66310298 315.55128866 -109.35762889 316.05851807 -120.55078125 315.9765625 C-121.85814743 315.97249893 -121.85814743 315.97249893 -123.19192505 315.96835327 C-137.42124357 315.90150008 -151.11972091 314.93915072 -164.98828125 311.5390625 C-165.74431641 311.35714355 -166.50035156 311.17522461 -167.27929688 310.98779297 C-172.27014785 309.74452444 -177.13067355 308.22492546 -181.98828125 306.5390625 C-182.81424805 306.25546875 -183.64021484 305.971875 -184.49121094 305.6796875 C-230.13044305 289.7758724 -267.40947404 255.66723789 -288.98828125 212.5390625 C-309.72770632 169.57323471 -311.61780093 118.54114232 -296.17578125 73.7265625 C-290.34214539 57.52731232 -281.86399962 41.86598216 -270.98828125 28.5390625 C-270.43011719 27.7965625 -269.87195313 27.0540625 -269.296875 26.2890625 C-259.37380729 13.25833859 -247.23063776 2.10979283 -233.98828125 -7.4609375 C-233.4277002 -7.87118164 -232.86711914 -8.28142578 -232.28955078 -8.70410156 C-206.34662146 -27.48651471 -175.75901325 -39.47394458 -143.98828125 -43.4609375 C-143.20501465 -43.55971191 -142.42174805 -43.65848633 -141.61474609 -43.76025391 C-91.29029694 -49.4506867 -38.57369099 -32.71045219 0 0 Z M-156.98828125 -18.4609375 C-158.48386463 -18.12661488 -159.97998874 -17.7947047 -161.4765625 -17.46484375 C-187.59609521 -11.43705163 -212.29040564 1.38876932 -231.89453125 19.65625 C-233.98828125 21.5390625 -233.98828125 21.5390625 -236.98828125 23.5390625 C-236.98828125 24.1990625 -236.98828125 24.8590625 -236.98828125 25.5390625 C-237.64828125 25.5390625 -238.30828125 25.5390625 -238.98828125 25.5390625 C-238.98828125 26.1990625 -238.98828125 26.8590625 -238.98828125 27.5390625 C-239.97828125 27.8690625 -240.96828125 28.1990625 -241.98828125 28.5390625 C-244.53603518 31.00941631 -246.72544483 33.80820971 -248.98828125 36.5390625 C-249.92027344 37.62380859 -249.92027344 37.62380859 -250.87109375 38.73046875 C-273.1153488 65.34252286 -284.33640902 98.58190279 -284.36328125 133.0390625 C-284.36527527 133.7133429 -284.36726929 134.38762329 -284.36932373 135.08233643 C-284.36630703 144.07839721 -283.62884328 152.69644865 -281.98828125 161.5390625 C-281.63636719 163.4571875 -281.63636719 163.4571875 -281.27734375 165.4140625 C-274.79811462 195.90455252 -260.59726193 222.16705285 -238.98828125 244.5390625 C-238.1375 245.45300781 -237.28671875 246.36695313 -236.41015625 247.30859375 C-215.11442486 269.5926001 -186.62636758 283.15327417 -156.98828125 290.5390625 C-156.31748535 290.71550293 -155.64668945 290.89194336 -154.95556641 291.07373047 C-130.52131545 297.25426675 -102.03362861 294.92174737 -77.98828125 288.5390625 C-76.40763331 288.15071092 -74.82690869 287.76267126 -73.24609375 287.375 C-63.12324673 284.76359239 -54.13105178 280.54475863 -44.98828125 275.5390625 C-44.06571533 275.0455127 -44.06571533 275.0455127 -43.12451172 274.54199219 C-5.15057649 254.19047895 21.36402071 217.96870374 33.82421875 177.1015625 C40.2692874 154.34959813 41.79447688 128.74802565 37.01171875 105.5390625 C36.86637695 104.80913086 36.72103516 104.07919922 36.57128906 103.32714844 C31.42913873 78.21169559 20.16896832 54.68144838 3.01171875 35.5390625 C2.56747559 35.03068848 2.12323242 34.52231445 1.66552734 33.99853516 C-20.16300893 9.03986915 -48.63884703 -8.29214696 -80.67578125 -16.7734375 C-81.58908203 -17.01594238 -82.50238281 -17.25844727 -83.44335938 -17.50830078 C-96.52744993 -20.80260472 -109.37428553 -21.84150899 -122.80078125 -21.7734375 C-123.54973663 -21.77161469 -124.29869202 -21.76979187 -125.07034302 -21.76791382 C-136.01891641 -21.72306836 -146.33797417 -21.18697465 -156.98828125 -18.4609375 Z ",
    fill: "#F0B308",
    transform: "translate(630.98828125,407.4609375)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.52876332 15.66061229 24.60330441 40.16942792 26.98754883 63.41137695 C29.16172406 93.41980663 27.42362597 130.63705222 6.84375 154.54296875 C-4.53742573 166.49498715 -18.10607426 171.80842352 -34.51953125 173.05078125 C-46.79569733 173.25973727 -58.21046917 171.12076928 -68.8359375 164.84765625 C-69.8671875 164.29078125 -70.8984375 163.73390625 -71.9609375 163.16015625 C-72.5796875 162.72703125 -73.1984375 162.29390625 -73.8359375 161.84765625 C-73.8359375 161.18765625 -73.8359375 160.52765625 -73.8359375 159.84765625 C-74.41859375 159.60144531 -75.00125 159.35523438 -75.6015625 159.1015625 C-86.97407866 152.71943368 -93.46474945 133.93021057 -97.02734375 122.0390625 C-100.48438868 108.39459047 -101.12262989 95.17560413 -101.1484375 81.16015625 C-101.15381531 79.98406296 -101.15381531 79.98406296 -101.15930176 78.78421021 C-101.19325496 64.95568486 -100.5361006 51.08509134 -96.6484375 37.72265625 C-96.43558105 36.97894775 -96.22272461 36.23523926 -96.00341797 35.46899414 C-90.74747461 18.01455536 -80.43865756 2.2913668 -64.0859375 -6.52734375 C-43.05967422 -16.20695344 -18.43843241 -13.99390669 0 0 Z ",
    fill: "#FEF9D9",
    transform: "translate(607.8359375,455.15234375)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.87532969 -0.0039821 1.75065938 -0.00796419 2.65251422 -0.01206696 C3.60970898 -0.00624128 4.56690374 -0.00041559 5.5531044 0.00558662 C6.57332664 0.00387777 7.59354887 0.00216892 8.64468694 0.00040829 C12.07339769 -0.00289372 15.50191403 0.00812893 18.93060684 0.01904488 C21.38436758 0.01960884 23.83812865 0.01929273 26.29188919 0.01815987 C31.57988117 0.01770399 36.86781229 0.0233877 42.15578842 0.03463554 C49.80131063 0.05088745 57.44680897 0.05609823 65.09234658 0.05861153 C77.49661743 0.06298912 89.90086199 0.07629995 102.30511856 0.09521675 C114.35492191 0.1135739 126.40471812 0.12773121 138.45453262 0.13623238 C139.56859913 0.13702055 139.56859913 0.13702055 140.70517203 0.13782464 C144.43112319 0.14043471 148.1570744 0.14296213 151.88302565 0.14544845 C182.79506402 0.16618294 213.70706972 0.20155885 244.6190834 0.24609566 C244.6190834 0.90609566 244.6190834 1.56609566 244.6190834 2.24609566 C245.2997084 2.43172066 245.9803334 2.61734566 246.6815834 2.80859566 C253.59633118 6.1924084 257.46357752 11.60456576 259.95892715 18.77734566 C262.03702099 26.54867883 260.18028543 33.18690821 256.6190834 40.24609566 C252.07018821 46.63340445 245.61757857 50.24611821 237.98920059 51.7722187 C234.11743119 52.31663369 230.29121692 52.48122828 226.38861465 52.55468941 C225.60515167 52.56990639 224.82168869 52.58512337 224.01448441 52.60080147 C195.30530432 53.05552515 195.30530432 53.05552515 182.3378334 47.91015816 C176.11128225 45.50266997 169.54884609 44.55752211 162.9940834 43.43359566 C161.21300186 43.12385811 161.21300186 43.12385811 159.39593887 42.80786324 C149.83442821 41.19256901 140.51004923 40.09375026 130.81048965 40.00781441 C129.43663353 39.99312363 129.43663353 39.99312363 128.03502274 39.97813606 C108.21437122 39.80982449 89.05071884 39.88402193 69.6190834 44.24609566 C68.51081192 44.49230659 67.40254044 44.73851753 66.26068497 44.99218941 C59.95364894 46.41618743 53.67263715 47.92543551 47.40961075 49.53174019 C46.48873672 49.76747749 45.5678627 50.0032148 44.6190834 50.24609566 C43.36103897 50.59809029 42.10299454 50.95008492 40.80682755 51.31274605 C36.59855718 52.35819997 32.60086353 52.55236316 28.27923965 52.54687691 C27.51284668 52.55116203 26.7464537 52.55544716 25.9568367 52.55986214 C24.34759884 52.56556499 22.73833522 52.56613583 21.12909317 52.56176949 C18.69105731 52.55860794 16.25423562 52.5821238 13.81634903 52.60742378 C3.22016317 52.65046575 -5.71975903 52.13565281 -14.3809166 45.24609566 C-19.9647499 39.40254917 -22.50303022 34.41006209 -22.8809166 26.43359566 C-22.6460189 18.90747363 -20.35509796 13.4002097 -15.1856041 7.91797066 C-6.54840534 -0.00658793 -6.54840534 -0.00658793 0 0 Z ",
    fill: "#FABF1F",
    transform: "translate(389.380916595459,279.75390434265137)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.79225983 0.00247742 1.58451965 0.00495483 2.40078735 0.00750732 C3.2350676 0.00239639 4.06934784 -0.00271454 4.9289093 -0.00798035 C7.69573068 -0.02191763 10.46230412 -0.02091647 13.22915649 -0.01861572 C15.14725335 -0.02250044 17.06534935 -0.02683464 18.98344421 -0.03160095 C23.00767808 -0.03907211 27.03182423 -0.03876546 31.05606079 -0.0335083 C36.21918655 -0.02771309 41.38195366 -0.04464158 46.5450201 -0.06785297 C50.50750334 -0.08256803 54.46989976 -0.08346505 58.43240547 -0.08034325 C60.33624545 -0.0808576 62.24009015 -0.08611666 64.14390373 -0.09615517 C66.80398899 -0.10845895 69.46337006 -0.10176455 72.1234436 -0.09014893 C73.308797 -0.10161453 73.308797 -0.10161453 74.51809692 -0.11331177 C79.84715272 -0.06174301 79.84715272 -0.06174301 82.27702332 1.68043518 C86.16040341 7.60555462 85.43912976 15.80804774 85.63931274 22.65716553 C85.69538696 24.40126709 85.69538696 24.40126709 85.75259399 26.18060303 C85.23810168 29.9283727 84.29860069 31.02253578 81.32681274 33.28216553 C78.30625113 34.2890194 76.1912666 34.43589239 73.02920532 34.48748779 C71.94831131 34.50743301 70.8674173 34.52737823 69.75376892 34.54792786 C68.5880687 34.56464035 67.42236847 34.58135284 66.22134399 34.59857178 C65.02700241 34.61935287 63.83266083 34.64013397 62.60212708 34.6615448 C58.78124832 34.72700829 54.96029999 34.78591062 51.13931274 34.84466553 C48.55141488 34.88785377 45.96352409 34.93146816 43.37564087 34.9755249 C37.02610181 35.08348947 30.67651108 35.18258734 24.32681274 35.28216553 C23.00681274 45.18216553 21.68681274 55.08216553 20.32681274 65.28216553 C22.80181274 64.78716553 22.80181274 64.78716553 25.32681274 64.28216553 C43.22633367 63.07498853 60.27514389 63.46200358 75.32681274 74.28216553 C76.37868774 75.02466553 77.43056274 75.76716553 78.51431274 76.53216553 C85.48426877 83.34723364 89.63994152 90.96587838 92.32681274 100.28216553 C92.66519165 101.43072021 92.66519165 101.43072021 93.01040649 102.60247803 C97.36350737 120.3150954 94.00921197 140.4720405 84.69400024 156.00482178 C75.03410483 170.36471116 61.97203447 178.48928389 44.98696899 181.96575928 C24.25194777 185.34773687 5.86370815 182.78616494 -12.67318726 173.28216553 C-13.60260132 172.80779053 -14.53201538 172.33341553 -15.48959351 171.84466553 C-17.72241311 170.47779161 -19.19155856 169.4377123 -20.67318726 167.28216553 C-21.32664916 163.72442848 -20.56848873 160.74799754 -19.67318726 157.28216553 C-19.38185913 156.07689209 -19.09053101 154.87161865 -18.79037476 153.62982178 C-15.79155618 142.18944699 -15.79155618 142.18944699 -12.67318726 140.28216553 C-7.60071196 140.63585853 -2.87861119 143.1250716 1.77993774 145.02825928 C9.10134931 147.61655566 16.01293943 148.64991972 23.76431274 148.59466553 C25.01099731 148.58620605 25.01099731 148.58620605 26.28286743 148.57757568 C35.0249456 148.40465169 42.30293381 147.21624942 48.85806274 141.03216553 C55.45464484 133.17240813 56.09892775 124.18216071 55.32681274 114.28216553 C53.7464106 108.0588203 51.11860892 101.58544668 45.43618774 98.13372803 C33.51277279 91.90705577 17.10053957 92.35717683 4.45181274 96.28216553 C2.85466431 96.82550537 2.85466431 96.82550537 1.22525024 97.37982178 C-2.988899 98.6917739 -6.2989104 98.79249783 -10.67318726 98.28216553 C-12.84861697 95.01902096 -12.92417549 94.11211117 -12.9168396 90.33880615 C-12.91761505 89.32765747 -12.9183905 88.31650879 -12.91918945 87.27471924 C-12.9076181 86.17373901 -12.89604675 85.07275879 -12.88412476 83.93841553 C-12.87746796 82.7868396 -12.87081116 81.63526367 -12.86395264 80.4487915 C-12.74348924 68.12320082 -12.17570701 55.82311201 -11.50131226 43.51702881 C-11.29532767 39.72958636 -11.10481416 35.94156169 -10.91537476 32.15325928 C-10.7860781 29.70659635 -10.65590299 27.25997964 -10.52474976 24.81341553 C-10.46945099 23.69978638 -10.41415222 22.58615723 -10.35717773 21.43878174 C-9.14654178 0.0897489 -9.14654178 0.0897489 0 0 Z ",
    fill: "#FEF8D9",
    transform: "translate(402.6731872558594,444.71783447265625)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.56198676 3.98737692 0.40483123 7.45797161 -0.625 11.4296875 C-0.80717575 12.16379852 -0.9893515 12.89790955 -1.17704773 13.65426636 C-1.57085998 15.23696006 -1.96889674 16.81860734 -2.37069702 18.39929199 C-3.22168975 21.74713809 -4.05276172 25.09982759 -4.88493347 28.45239258 C-5.30935646 30.16147352 -5.73482917 31.87029411 -6.16133118 33.57885742 C-8.08261769 41.28490158 -9.90026772 49.01181155 -11.6875 56.75 C-12.24715009 59.15760922 -12.80704182 61.56516228 -13.3671875 63.97265625 C-14.19542142 67.5360459 -15.02306357 71.09956616 -15.84863281 74.66357422 C-16.66381876 78.17301084 -17.48714543 81.68044295 -18.3125 85.1875 C-18.67637817 86.7657959 -18.67637817 86.7657959 -19.04760742 88.37597656 C-19.38949097 89.8198877 -19.38949097 89.8198877 -19.73828125 91.29296875 C-19.93462158 92.1336792 -20.13096191 92.97438965 -20.33325195 93.84057617 C-21 96 -21 96 -23 99 C-25.34114526 96.04777314 -27.67155454 93.08725012 -30 90.125 C-30.66773438 89.28324219 -31.33546875 88.44148438 -32.0234375 87.57421875 C-32.65507812 86.76855469 -33.28671875 85.96289062 -33.9375 85.1328125 C-34.52402344 84.38918457 -35.11054688 83.64555664 -35.71484375 82.87939453 C-37 81 -37 81 -37 79 C-37.66 79 -38.32 79 -39 79 C-39.17740723 79.54309814 -39.35481445 80.08619629 -39.53759766 80.64575195 C-40.84597078 84.61550394 -42.19048037 88.56296382 -43.6484375 92.48046875 C-53.27088276 118.5452846 -57.22756271 144.75925586 -57.1875 172.4375 C-57.18623108 173.33349915 -57.18496216 174.22949829 -57.18365479 175.15264893 C-57.05484007 222.74702545 -44.14759607 269.42771049 -17 309 C-16.29858887 310.03858154 -16.29858887 310.03858154 -15.58300781 311.09814453 C-6.92287353 323.8828319 2.68586522 335.4511928 13.08203125 346.859375 C14.63983327 348.59802166 16.11407777 350.35892709 17.5625 352.1875 C20.08713848 355.1005444 22.77720291 357.466952 25.70703125 359.95703125 C28.36223192 362.32273815 30.82651079 364.83226923 33.3125 367.375 C34.26377089 368.31827975 35.21690691 369.25968219 36.171875 370.19921875 C37.98944067 371.99921127 39.77428474 373.83319771 41.515625 375.70703125 C46.42301374 380.4864666 49.92687893 382.41543605 56.69897461 382.41333008 C58.22782442 382.348108 59.7557595 382.24860195 61.27954102 382.1081543 C71.84701482 381.22939409 79.80188066 386.81678902 88.1875 392.625 C90.03645326 393.88151789 91.88541162 395.13802826 93.734375 396.39453125 C94.63091797 397.00893066 95.52746094 397.62333008 96.45117188 398.25634766 C99.92878192 400.63537935 103.42997034 402.97790027 106.9375 405.3125 C107.5243457 405.704375 108.11119141 406.09625 108.71582031 406.5 C115.09137913 410.74800465 121.54127649 414.87995142 128 419 C124.72412278 421.18391814 121.698826 422.02351595 117.9375 422.9375 C117.24591797 423.10862305 116.55433594 423.27974609 115.84179688 423.45605469 C107.64101174 425.4202927 99.3312072 426.72717668 91 428 C91.54527344 428.83660156 92.09054687 429.67320312 92.65234375 430.53515625 C96.85027578 437.00434696 100.96764997 443.51295145 104.9375 450.125 C105.50295532 451.06484741 105.50295532 451.06484741 106.07983398 452.02368164 C107.83727043 454.96767772 109.48918433 457.92332377 111 461 C103.29065674 459.17972555 96.47132937 456.6243014 89.4375 453 C88.49293945 452.51869629 87.54837891 452.03739258 86.57519531 451.54150391 C73.3172009 444.68983296 60.60446114 437.62619159 50 427 C48.6078125 425.7934375 48.6078125 425.7934375 47.1875 424.5625 C41.44179752 417.83181995 39.80779108 412.096271 39.8125 403.4375 C39.76363124 398.89912244 39.66302291 395.94773275 37.0078125 392.15234375 C34.44334457 389.8801784 31.80555746 387.96501095 29 386 C22.36054046 380.63139694 16.38013065 374.5343966 10.36230469 368.49267578 C8.74266462 366.86764019 7.11770007 365.24806535 5.4921875 363.62890625 C4.44759562 362.58365408 3.40331372 361.53809201 2.359375 360.4921875 C1.88014587 360.0149826 1.40091675 359.53777771 0.90716553 359.04611206 C-7 351.08409165 -7 351.08409165 -7 348 C-7.66 348 -8.32 348 -9 348 C-10.22998047 346.70922852 -10.22998047 346.70922852 -11.6171875 344.87890625 C-12.13531006 344.20021484 -12.65343262 343.52152344 -13.18725586 342.82226562 C-13.74421143 342.07654297 -14.30116699 341.33082031 -14.875 340.5625 C-15.45580322 339.78970703 -16.03660645 339.01691406 -16.63500977 338.22070312 C-17.8438715 336.60473049 -19.04864794 334.98569445 -20.24951172 333.36376953 C-21.34720878 331.88149576 -22.44967713 330.40273075 -23.55908203 328.92919922 C-63.45083392 275.84136665 -81.1511927 206.37409392 -71.84375 140.66015625 C-71.56296112 138.77336882 -71.2817391 136.88664578 -71 135 C-70.78044223 133.39464152 -70.56163893 131.78917959 -70.34375 130.18359375 C-67.33781767 109.15805643 -59.86369854 89.62657817 -52 70 C-53.37889404 69.78935913 -53.37889404 69.78935913 -54.78564453 69.57446289 C-58.38156199 68.93180804 -61.48369249 67.78710197 -64.875 66.4375 C-66.02742187 65.98246094 -67.17984375 65.52742188 -68.3671875 65.05859375 C-69.67042969 64.53458984 -69.67042969 64.53458984 -71 64 C-69.46488177 60.35839901 -67.28003346 58.03556785 -64.4921875 55.26171875 C-63.58726562 54.35873047 -62.68234375 53.45574219 -61.75 52.52539062 C-61.04037109 51.82506714 -61.04037109 51.82506714 -60.31640625 51.1105957 C-58.89541817 49.70765879 -57.48279557 48.29626507 -56.0703125 46.88476562 C-50.87223467 41.71972642 -45.57888328 36.74940723 -40 32 C-38.87023727 31.01530471 -37.74130338 30.02965751 -36.61328125 29.04296875 C-29.47936232 22.85504864 -22.20445846 16.95006755 -14.66601562 11.26171875 C-11.65910134 8.98450113 -8.67498608 6.67760623 -5.6875 4.375 C-4.58733211 3.52852557 -3.48708068 2.68215969 -2.38671875 1.8359375 C-1.59910156 1.23007812 -0.81148438 0.62421875 0 0 Z ",
    fill: "#12815B",
    transform: "translate(279,347)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.08993042 5.36027554 19.02280811 11.58054953 28.0625 18.53466797 C30.98761797 20.74693587 33.99372314 22.8377418 37 24.9375 C44.34645851 30.10910332 51.25448056 35.7919702 58.18164062 41.50634766 C62.08645574 44.71387436 66.04577836 47.8537323 70 51 C66.63086351 53.81183572 62.94821665 55.50075001 58.9375 57.1875 C58.31294922 57.46013672 57.68839844 57.73277344 57.04492188 58.01367188 C54.190309 59.22924342 52.13560401 60 49 60 C49.36967896 60.9115686 49.36967896 60.9115686 49.74682617 61.84155273 C57.79533847 81.7834559 63.65969117 100.7431247 67 122 C67.12004395 122.7213916 67.24008789 123.4427832 67.36376953 124.18603516 C72.07069489 153.22025882 70.13472415 185.60031753 63 214 C62.72542969 215.216875 62.45085937 216.43375 62.16796875 217.6875 C52.21780315 261.10838704 28.84007117 300.69792278 1 335 C0.34040283 335.81839355 0.34040283 335.81839355 -0.33251953 336.65332031 C-25.68865485 367.89386952 -25.68865485 367.89386952 -40.81933594 377.10791016 C-42.80649671 378.27762963 -42.80649671 378.27762963 -45 381 C-45.29902592 383.99918534 -45.17916503 386.86167958 -45.03515625 389.87109375 C-44.93954291 398.38068122 -48.48742748 404.78262369 -54 411 C-54.56460938 411.65742187 -55.12921875 412.31484375 -55.7109375 412.9921875 C-69.62267438 428.07791062 -95.4263051 440.28977923 -115 446 C-115.66 445.67 -116.32 445.34 -117 445 C-116.52433594 444.32130859 -116.52433594 444.32130859 -116.0390625 443.62890625 C-111.00269316 436.26912896 -106.57171331 428.56398946 -102.08837891 420.86132812 C-100.74437063 418.56282677 -99.37713923 416.27878414 -98 414 C-99.20914063 414.03867187 -100.41828125 414.07734375 -101.6640625 414.1171875 C-107.9920476 414.11470885 -114.13730598 413.10989906 -120.375 412.125 C-122.13650391 411.86396484 -122.13650391 411.86396484 -123.93359375 411.59765625 C-125.61775391 411.33662109 -125.61775391 411.33662109 -127.3359375 411.0703125 C-128.35220215 410.91320801 -129.3684668 410.75610352 -130.41552734 410.59423828 C-133 410 -133 410 -136 408 C-134.36417969 407.03513672 -134.36417969 407.03513672 -132.6953125 406.05078125 C-120.47880335 398.76302053 -108.98296869 390.73219019 -97.60498047 382.20507812 C-95.99845141 381.00123421 -94.38860776 379.80180022 -92.77539062 378.60693359 C-91.26767177 377.48999985 -89.76705452 376.36338408 -88.27539062 375.22509766 C-80.35185272 369.37122337 -73.6158927 367.58391165 -63.875 368.25 C-58.00527906 368.52883741 -58.00527906 368.52883741 -52.5625 366.69921875 C-50.84309053 364.99320325 -50.84309053 364.99320325 -49.55249023 363.05273438 C-48.00206078 361.00272481 -46.44401339 359.5342727 -44.47265625 357.89453125 C-39.25828784 353.42294867 -34.41949307 348.60349127 -29.5625 343.75 C-28.67240234 342.87214844 -27.78230469 341.99429687 -26.86523438 341.08984375 C-20.80432352 335.04221466 -15.30154982 328.71942845 -10 322 C-9.43015381 321.2894043 -8.86030762 320.57880859 -8.27319336 319.84667969 C29.23630055 272.85944954 52.51276062 215.38374032 52.375 155 C52.37368576 153.58501724 52.37368576 153.58501724 52.37234497 152.14144897 C52.30151574 128.95774427 51.53630945 87.53630945 34 70 C33.31292969 70.96421875 32.62585938 71.9284375 31.91796875 72.921875 C31.00783788 74.19793477 30.09768022 75.47397543 29.1875 76.75 C28.50977539 77.70132813 28.50977539 77.70132813 27.81835938 78.671875 C26.94048723 79.90217757 26.06019363 81.13075666 25.17724609 82.35742188 C24.20539792 83.7134141 23.2507313 85.08170286 22.30078125 86.453125 C21.87152344 86.96359375 21.44226563 87.4740625 21 88 C20.34 88 19.68 88 19 88 C18.69147095 86.59983643 18.69147095 86.59983643 18.37670898 85.17138672 C17.39924591 80.73875433 16.41867323 76.30681243 15.4375 71.875 C15.25803833 71.06367615 15.07857666 70.25235229 14.89367676 69.41644287 C12.43194134 58.29757718 9.88397784 47.20426919 7.25 36.125 C4.41121701 24.14823671 2.03149519 12.1384992 0 0 Z ",
    fill: "#13805A",
    transform: "translate(739,364)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74804688 1.51708984 1.74804688 1.51708984 3 3 C2.61368408 4.07854248 2.22736816 5.15708496 1.8293457 6.26831055 C-0.01096432 11.40755358 -1.84954112 16.5474157 -3.6875 21.6875 C-4.02535522 22.63226196 -4.36321045 23.57702393 -4.71130371 24.55041504 C-9.70987923 38.53332361 -14.65282885 52.53463182 -19.55493164 66.55160522 C-23.60167444 78.11396935 -27.77437399 89.62343529 -32.02368164 101.11279297 C-36.89574639 114.33503787 -41.46333463 127.65967102 -46 141 C-48.33447266 141.22900391 -48.33447266 141.22900391 -51 141 C-52.46630859 139.47802734 -52.46630859 139.47802734 -53.6484375 137.3359375 C-54.3144397 136.15874146 -54.3144397 136.15874146 -54.99389648 134.95776367 C-55.44966064 134.10545166 -55.9054248 133.25313965 -56.375 132.375 C-56.85976807 131.50270752 -57.34453613 130.63041504 -57.84399414 129.73168945 C-61.09664412 123.82985664 -64.14279337 117.840887 -67.09765625 111.78515625 C-69.38796797 107.15850264 -71.88810464 102.6480846 -74.375 98.125 C-79.54819237 88.71320811 -84.60176555 79.24227622 -89.625 69.75 C-95.61971987 58.42559043 -101.69421207 47.15520223 -108 36 C-108.99 36 -109.98 36 -111 36 C-110.67 35.01 -110.34 34.02 -110 33 C-111.41488448 30.23760649 -112.80363095 28.19636905 -115 26 C-115 24.68 -115 23.36 -115 22 C-112.76962261 21.4384323 -110.53717265 20.88881427 -108.30078125 20.3515625 C-102.73586525 18.9985241 -97.31225133 17.53577464 -91.9375 15.55078125 C-90 15 -90 15 -86 15 C-85.67 14.34 -85.34 13.68 -85 13 C-83.12890625 12.5078125 -83.12890625 12.5078125 -80.5625 12.125 C-74.40180108 11.12115418 -68.35488077 9.757789 -62.28344727 8.32080078 C-58.44640393 7.4384436 -54.96848671 6.76283944 -51 7 C-50.67 6.34 -50.34 5.68 -50 5 C-47.62567176 4.57879854 -45.33316251 4.28845453 -42.9375 4.0625 C-41.3943724 3.90125259 -39.85141246 3.73839533 -38.30859375 3.57421875 C-37.04184814 3.44152588 -37.04184814 3.44152588 -35.74951172 3.30615234 C-32.77690998 2.9751594 -29.81314331 2.59655971 -26.84765625 2.20703125 C-25.2709314 2.00098267 -25.2709314 2.00098267 -23.66235352 1.79077148 C-21.59596586 1.51909248 -19.530022 1.24401045 -17.46459961 0.96508789 C-11.59471281 0.2063751 -5.91695521 -0.40766424 0 0 Z ",
    fill: "#EF6340",
    transform: "translate(435,139)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.95638466 8.25696464 13.48556205 20.56752101 15 33 C15.11085938 33.88945313 15.22171875 34.77890625 15.3359375 35.6953125 C17.40296839 56.64494989 19.87220975 87.40940548 7.125 105.5625 C2.55848364 111.01248812 -2.95448695 114.36931087 -10.0625 115.2578125 C-16.81140793 115.60931812 -22.53654848 113.90160272 -27.7578125 109.52734375 C-37.8585322 98.79215674 -39.12412024 82.19118675 -39.203125 68.1875 C-39.20882507 67.37490723 -39.21452515 66.56231445 -39.22039795 65.72509766 C-39.22977838 64.01417309 -39.23635395 62.30323103 -39.24023438 60.59228516 C-39.24987252 58.03384021 -39.28093487 55.47622376 -39.3125 52.91796875 C-39.42838955 34.80771241 -38.14991779 14.74225643 -25 1 C-17.69796557 -4.43407214 -7.79404344 -4.70669419 0 0 Z ",
    fill: "#FDC324",
    transform: "translate(583,479)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.49608773 0.01005392 2.99218203 0.01917549 4.48828125 0.02734375 C8.11732626 0.04915692 11.74611985 0.08355259 15.375 0.125 C15.375 0.455 15.375 0.785 15.375 1.125 C12.075 1.125 8.775 1.125 5.375 1.125 C5.13652344 2.37925781 4.89804687 3.63351563 4.65234375 4.92578125 C3.37337822 10.65934462 1.19393862 15.904017 -1.0625 21.3125 C-5.02811335 31.01727777 -8.78440257 40.77701195 -12.375 50.625 C-12.72683853 51.58900223 -12.72683853 51.58900223 -13.08578491 52.57247925 C-15.96957194 60.4830487 -18.80216013 68.41055153 -21.56616211 76.36376953 C-23.23483664 81.12713129 -25.06920744 85.81192091 -26.9375 90.5 C-30.4521722 99.33513829 -33.42407878 108.33633477 -36.34106445 117.38427734 C-38.75728831 124.80502585 -41.54246414 131.95404816 -44.625 139.125 C-50.565 139.125 -56.505 139.125 -62.625 139.125 C-61.28229591 127.63107209 -57.40767025 117.37204721 -53.4375 106.5625 C-52.7822697 104.75489537 -52.12796741 102.94695408 -51.47460938 101.13867188 C-48.99010435 94.27691643 -46.48244109 87.42383814 -43.93823242 80.58398438 C-38.77256084 66.6831963 -33.87943853 52.68849269 -28.98968506 38.68878174 C-27.40624414 34.15538826 -25.82189771 29.62231245 -24.23554993 25.0899353 C-23.39638504 22.69190326 -22.55827195 20.29350282 -21.72135925 17.89468384 C-21.34368912 16.81520477 -20.96601898 15.73572571 -20.5769043 14.62353516 C-20.2471611 13.67934723 -19.91741791 12.7351593 -19.5776825 11.76235962 C-18.6490647 9.19161953 -17.65569331 6.65633448 -16.625 4.125 C-19.925 3.795 -23.225 3.465 -26.625 3.125 C-26.625 2.795 -26.625 2.465 -26.625 2.125 C-17.79895275 -0.25961892 -9.05334797 -0.10655728 0 0 Z ",
    fill: "#DB4525",
    transform: "translate(453.625,137.875)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.01458252 1.11221924 1.02916504 2.22443848 1.04418945 3.37036133 C1.10325925 7.59590922 1.18045649 11.82098268 1.26245117 16.04614258 C1.29520018 17.85628416 1.32337769 19.66651567 1.34643555 21.47680664 C1.69476078 48.13480404 5.55539452 77.26649365 24.5546875 97.6796875 C25.9833328 99.10544584 25.9833328 99.10544584 28 100 C28 100.66 28 101.32 28 102 C29.10214844 102.41958984 29.10214844 102.41958984 30.2265625 102.84765625 C32.74645567 103.89465412 35.00165796 105.10093369 37.375 106.4375 C53.57093523 114.5836698 71.21029992 112.94440705 88 108 C98.41730461 104.33913843 106.54341026 96.72508243 112.74609375 87.7265625 C114.0265619 85.96342567 115.42284042 84.49899132 117 83 C115.41440451 94.09916844 108.83191549 100.47860098 101 108 C100.24203125 108.81726563 99.4840625 109.63453125 98.703125 110.4765625 C86.87957818 121.51415101 70.6409988 123.76832529 55.1796875 123.34765625 C40.76809361 122.61419498 27.94101126 116.45877226 18 106 C15.41512803 102.80660608 13.16031717 99.49260123 11 96 C10.54753906 95.27554688 10.09507812 94.55109375 9.62890625 93.8046875 C5.35450099 86.16135847 3.60474977 77.62369944 1.55273438 69.18237305 C1.03987566 67.15744193 0.46558809 65.16385954 -0.13671875 63.1640625 C-1.09246403 59.66110468 -1.14752072 56.61425756 -1 53 C-0.34 53 0.32 53 1 53 C0.7834375 51.52080078 0.7834375 51.52080078 0.5625 50.01171875 C-0.74370076 40.2855827 -1.1928348 30.68903095 -1.1875 20.875 C-1.18814453 19.72604248 -1.18878906 18.57708496 -1.18945312 17.39331055 C-1.15157354 11.50690931 -0.88941517 5.8203329 0 0 Z ",
    fill: "#F4AF0D",
    transform: "translate(506,515)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.855625 1.11375 0.71125 2.2275 0.5625 3.375 C-0.04796371 8.24126788 -0.52985225 13.11846586 -1 18 C16.06791422 30.73320585 36.27797019 35.18243049 57.26171875 32.49609375 C75.15214688 29.86302671 89.63682795 23.45269809 101 9 C102.42521639 7.03529492 103.72696951 5.06867455 105 3 C106.19393714 6.58181143 105.83195691 7.13814466 104.25 10.4375 C95.77932657 26.55301519 80.41934602 36.63436784 63.50976562 42.15771484 C57.61689443 43.57190555 51.78728555 43.59314962 45.76464844 43.52148438 C43.63359948 43.50008635 41.50594572 43.52136644 39.375 43.546875 C26.17954157 43.57327354 9.21663963 41.11689819 -1.04296875 32.23046875 C-5.41727751 27.29508476 -6.12511833 23.63127142 -6 17 C-5.34 17 -4.68 17 -4 17 C-3.87882812 16.27554688 -3.75765625 15.55109375 -3.6328125 14.8046875 C-2.75060421 9.71502427 -1.83557653 4.85116654 0 0 Z ",
    fill: "#F4B10E",
    transform: "translate(384,594)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.99777939 0.64701874 0.99555878 1.29403748 0.99327087 1.96066284 C0.97120032 8.67608083 0.95608596 15.39148856 0.94506836 22.10693359 C0.94002997 24.61540139 0.93319916 27.12386624 0.92456055 29.63232422 C0.91247339 33.2314527 0.90676685 36.83054247 0.90234375 40.4296875 C0.89718246 41.55680145 0.89202118 42.68391541 0.88670349 43.84518433 C0.88662796 44.88611237 0.88655243 45.92704041 0.88647461 46.99951172 C0.884254 47.91884491 0.88203339 48.8381781 0.87974548 49.78536987 C0.85489471 52.04150588 0.85489471 52.04150588 2 54 C7.65665216 54.39011394 11.75850549 53.84961704 17.125 52 C23.73968958 49.97303406 29.90756926 49.58452881 36.8125 49.5625 C38.26197021 49.54799805 38.26197021 49.54799805 39.74072266 49.53320312 C48.44063833 49.63486909 55.98252404 51.19371726 62.49609375 57.25390625 C68.11910621 63.78244279 69.13833819 70.6997085 69 79 C68.34 78.01 67.68 77.02 67 76 C66.67 77.98 66.34 79.96 66 82 C65.67 82 65.34 82 65 82 C64.85304688 81.43152344 64.70609375 80.86304688 64.5546875 80.27734375 C62.4669353 73.09019681 59.91708698 68.19467994 53.24609375 64.45703125 C38.34910058 57.93159989 23.46788547 61.2514567 8.375 65.1875 C5.36734088 65.91156608 3.0569496 66.43670709 0 66 C-2.5048111 64.12139167 -2.98700625 63.03898126 -4 60 C-4.0685495 58.10529184 -4.08480372 56.2083166 -4.0625 54.3125 C-4.05347656 53.31863281 -4.04445313 52.32476563 -4.03515625 51.30078125 C-4.02355469 50.54152344 -4.01195312 49.78226563 -4 49 C-3.67 49 -3.34 49 -3 49 C-2.01 32.83 -1.02 16.66 0 0 Z ",
    fill: "#F5B00E",
    transform: "translate(390,488)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.8830837 -0.09264076 21.76607374 -0.16373496 32.64947128 -0.20724869 C37.7029792 -0.22813214 42.75621755 -0.25646371 47.80957031 -0.30175781 C52.68547468 -0.34518839 57.5611196 -0.3691314 62.43720245 -0.37950897 C64.29838394 -0.38690535 66.15955108 -0.40134866 68.02062225 -0.42292023 C70.62571504 -0.45191744 73.22973298 -0.45595759 75.83496094 -0.45410156 C76.99158234 -0.47567322 76.99158234 -0.47567322 78.17156982 -0.49768066 C81.69188551 -0.47050483 83.62455816 -0.28608381 86.46395874 1.8775177 C89.25890197 5.73953475 89.12708387 9.74731257 89.1328125 14.37890625 C89.13410156 15.38244141 89.13539063 16.38597656 89.13671875 17.41992188 C89.13285156 18.45697266 89.12898438 19.49402344 89.125 20.5625 C89.12886719 21.60341797 89.13273437 22.64433594 89.13671875 23.71679688 C89.13542969 24.71904297 89.13414062 25.72128906 89.1328125 26.75390625 C89.13168457 27.66470947 89.13055664 28.5755127 89.12939453 29.51391602 C88.86549049 34.58435915 87.74838832 36.56397738 84 40 C83.154375 40.886875 82.30875 41.77375 81.4375 42.6875 C77.13820108 46.76632206 72.66317802 46.15416206 67.0625 46.125 C66.16184814 46.12306641 65.26119629 46.12113281 64.33325195 46.11914062 C51.88205169 46.04376129 39.43955212 45.51045199 27 45 C26.67 48.3 26.34 51.6 26 55 C25.67 55 25.34 55 25 55 C24.89364074 48.57117333 24.94126925 42.35238448 26 36 C27.66914646 34.33085354 29.69767896 34.84957496 31.99121094 34.82641602 C33.05611755 34.81292618 34.12102417 34.79943634 35.21820068 34.78553772 C36.37853821 34.77509933 37.53887573 34.76466095 38.734375 34.75390625 C41.16927434 34.72096111 43.60417008 34.68774958 46.0390625 34.65429688 C49.89483095 34.60689794 53.75058551 34.56249403 57.60644531 34.52319336 C61.31591435 34.48347283 65.02507544 34.43191734 68.734375 34.37890625 C69.8866156 34.3704921 71.0388562 34.36207794 72.22601318 34.35340881 C73.30352844 34.33676682 74.3810437 34.32012482 75.49121094 34.30297852 C76.90898834 34.28751732 76.90898834 34.28751732 78.35540771 34.27174377 C81.24662038 33.97465864 83.40303894 33.29492554 86 32 C89.83382762 24.33234476 87.0516246 10.2064984 85 2 C56.95 1.67 28.9 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F6AD0C",
    transform: "translate(400,444)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.95638466 8.25696464 13.48556205 20.56752101 15 33 C15.11085938 33.88945313 15.22171875 34.77890625 15.3359375 35.6953125 C16.09703271 43.4091153 16.10153951 51.1296868 16.125 58.875 C16.12967285 59.9573291 16.1343457 61.0396582 16.13916016 62.15478516 C16.12830079 67.54353536 15.95260746 72.6926156 15 78 C14.67 78 14.34 78 14 78 C13.505 65.13 13.505 65.13 13 52 C12.01 52.495 12.01 52.495 11 53 C10.78085937 51.9584375 10.56171875 50.916875 10.3359375 49.84375 C5.76480793 27.02396602 5.76480793 27.02396602 -8.25 9.5 C-14.06606669 6.56611747 -20.86602424 7.6149087 -27 9 C-27.33 8.67 -27.66 8.34 -28 8 C-28.99 8.99 -29.98 9.98 -31 11 C-29.37241288 5.96927617 -26.82549911 1.62148557 -22.17578125 -1.046875 C-14.79189394 -4.12228582 -6.96098895 -4.20362634 0 0 Z ",
    fill: "#F6B413",
    transform: "translate(583,479)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 0 6 C1.19528887 5.99907821 2.39057774 5.99815641 3.62208748 5.99720669 C31.99541524 5.97554915 60.36874279 5.95905963 88.742077 5.94893467 C92.23430135 5.94768396 95.72652568 5.94638964 99.21875 5.94506836 C99.91398938 5.94480605 100.60922876 5.94454374 101.325536 5.94427348 C112.58294114 5.9399221 123.84034118 5.93203747 135.09774329 5.9228472 C146.64875898 5.91349588 158.19977108 5.9080161 169.75079048 5.90591151 C176.23885529 5.90460655 182.72690853 5.90153418 189.21496964 5.89426994 C195.31992327 5.88748994 201.42486054 5.8853871 207.52981758 5.88689232 C209.77197801 5.88661689 212.01413898 5.8846235 214.25629616 5.88079453 C217.31518158 5.8758264 220.37400502 5.8770133 223.43289185 5.87974548 C224.7665627 5.87537622 224.7665627 5.87537622 226.1271764 5.87091869 C230.53376938 5.8815719 234.66141811 6.11047753 239 7 C239 7.33 239 7.66 239 8 C159.47 8 79.94 8 -2 8 C-1.34 5.36 -0.68 2.72 0 0 Z ",
    fill: "#E94332",
    transform: "translate(391,272)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.57 0 19.14 0 29 0 C29 0.33 29 0.66 29 1 C31.475 1.495 31.475 1.495 34 2 C30.54785147 4.30143236 29.76520676 4.13833854 25.8125 3.625 C24.91144531 3.51414062 24.01039063 3.40328125 23.08203125 3.2890625 C22.39496094 3.19367188 21.70789063 3.09828125 21 3 C22.13304992 6.39914975 23.12518475 7.05254451 26 9 C22.18200446 8.32623608 18.66175456 7.26753042 15 6 C13.50054025 5.49838217 12.00050276 4.99848917 10.5 4.5 C5.25 2.75 5.25 2.75 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#35B661",
    transform: "translate(587,331)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C4.43718668 10.76606807 5.19390458 21.38223625 5.1875 32.25 C5.18814453 33.30823975 5.18878906 34.36647949 5.18945312 35.45678711 C5.15235709 40.73833461 4.91868165 45.79658714 4 51 C3.67 51 3.34 51 3 51 C2.67 38.46 2.34 25.92 2 13 C1.67 13 1.34 13 1 13 C0.67 8.71 0.34 4.42 0 0 Z ",
    fill: "#F7B326",
    transform: "translate(594,506)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.2575 1.66 1.515 2.32 0.75 3 C-2.46984249 6.20159976 -4.13940171 9.91318367 -6 14 C-6.66201689 15.33564811 -7.32741405 16.66964277 -8 18 C-8.33 18 -8.66 18 -9 18 C-9.66 20.64 -10.32 23.28 -11 26 C-11.33 26 -11.66 26 -12 26 C-12.36552803 24.58622218 -12.71695495 23.16879424 -13.0625 21.75 C-13.25972656 20.96109375 -13.45695313 20.1721875 -13.66015625 19.359375 C-14.01497267 16.89605178 -13.76877544 15.34395868 -13 13 C-12.67 13.33 -12.34 13.66 -12 14 C-12 13.34 -12 12.68 -12 12 C-12.66 11.34 -13.32 10.68 -14 10 C-11.69 10 -9.38 10 -7 10 C-6.773125 9.278125 -6.54625 8.55625 -6.3125 7.8125 C-4.75168987 4.46790687 -2.6968713 2.48396041 0 0 Z M-10 13 C-10.33 13.66 -10.66 14.32 -11 15 C-10.34 15 -9.68 15 -9 15 C-9.33 14.34 -9.66 13.68 -10 13 Z M-12 16 C-11.67 16.66 -11.34 17.32 -11 18 C-10.67 17.34 -10.34 16.68 -10 16 C-10.66 16 -11.32 16 -12 16 Z ",
    fill: "#32BB71",
    transform: "translate(735,334)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.20603883 1.55969457 4.749495 2.48429763 6.33203125 5.7421875 C8.19572779 9.382288 10.56707746 12.08583174 13.375 15 C14.32168506 15.99870072 15.26700292 16.99869923 16.2109375 18 C16.67371094 18.49032715 17.13648438 18.9806543 17.61328125 19.48583984 C19.83655311 21.91343352 21.90481404 24.46146412 24 27 C28.38951075 31.63337246 33.20770302 35.79238413 38 40 C34.52506333 40 34.23191689 39.63368435 31.8125 37.359375 C31.20164551 36.78944824 30.59079102 36.21952148 29.96142578 35.63232422 C29.31415527 35.01115723 28.66688477 34.38999023 28 33.75 C27.33081543 33.11465332 26.66163086 32.47930664 25.97216797 31.82470703 C16.44119761 22.69019587 7.29283847 13.05630326 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F2DB17",
    transform: "translate(323,671)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.81 0 37.62 0 57 0 C57 0.33 57 0.66 57 1 C39.18 1 21.36 1 3 1 C2.67 2.32 2.34 3.64 2 5 C1.34 4.67 0.68 4.34 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#F7BC20",
    transform: "translate(426,480)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34644531 2.36738281 0.69289063 2.73476563 0.01953125 3.11328125 C-3.93508607 5.58427758 -7.60928426 8.35753518 -11.3125 11.1875 C-12.06781006 11.76395264 -12.82312012 12.34040527 -13.60131836 12.93432617 C-18.78418064 16.94041142 -23.63145073 21.09833963 -28 26 C-28 23 -28 23 -26.70703125 21.30859375 C-18.57176044 13.27396546 -9.36358799 6.53273581 0 0 Z ",
    fill: "#F8DD13",
    transform: "translate(381,355)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.39453125 4.42578125 C-2.18923828 5.20501953 -2.18923828 5.20501953 -3 6 C-3.98628417 8.03077684 -3.98628417 8.03077684 -4.6875 10.1875 C-4.93886719 10.90292969 -5.19023437 11.61835938 -5.44921875 12.35546875 C-5.72185547 13.16951172 -5.72185547 13.16951172 -6 14 C-6.66 14 -7.32 14 -8 14 C-8 18.95 -8 23.9 -8 29 C-10.60845923 26.39154077 -10.35780384 25.1378953 -10.4375 21.5 C-10.30661851 13.7125514 -7.65270285 7.44950691 -2.1875 1.875 C-1.465625 1.25625 -0.74375 0.6375 0 0 Z ",
    fill: "#F8CF11",
    transform: "translate(377,285)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.25 0 16.5 0 25 0 C25 0.66 25 1.32 25 2 C18.565 2.495 18.565 2.495 12 3 C12.66 3.66 13.32 4.32 14 5 C8.94744036 4.36843005 4.70406799 2.86540627 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#13A585",
    transform: "translate(587,331)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74949772 2.62424658 2.65389981 4.55727216 3.625 7.5 C3.88539063 8.2734375 4.14578125 9.046875 4.4140625 9.84375 C5 12 5 12 5 15 C5.66 15.33 6.32 15.66 7 16 C6.67 17.65 6.34 19.3 6 21 C3.90250005 18.64031256 3.03094296 17.45383006 2.8125 14.25 C2.9053125 13.13625 2.9053125 13.13625 3 12 C2.34 12 1.68 12 1 12 C-1.83022097 8.00439392 -0.76210446 4.57262677 0 0 Z ",
    fill: "#36C175",
    transform: "translate(881,391)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.66 -0.66 1.32 -1 2 C-1.99 2 -2.98 2 -4 2 C-4 3.98 -4 5.96 -4 8 C-4.66 8 -5.32 8 -6 8 C-6.33 8.66 -6.66 9.32 -7 10 C-11 5.5 -11 5.5 -11 1 C-2.43902439 -1.2195122 -2.43902439 -1.2195122 0 0 Z ",
    fill: "#E57555",
    transform: "translate(331,160)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.64453125 4.8671875 C-2.35996094 5.52976562 -3.07539063 6.19234375 -3.8125 6.875 C-6.7790539 9.72079153 -9.14128483 12.28256967 -11 16 C-11.99 15.67 -12.98 15.34 -14 15 C-16.00812926 15.98357352 -18.00854609 16.98308736 -20 18 C-20.66 17.67 -21.32 17.34 -22 17 C-21.0821875 16.443125 -20.164375 15.88625 -19.21875 15.3125 C-12.00517605 10.85486107 -5.64466526 6.433516 0 0 Z ",
    fill: "#F4A109",
    transform: "translate(484,605)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-2.4363189 2.67126129 -4.87388883 3.33716354 -7.3125 4 C-8.00279297 4.19078125 -8.69308594 4.3815625 -9.40429688 4.578125 C-12.35787949 5.37716184 -14.92559219 6 -18 6 C-18.33 5.01 -18.66 4.02 -19 3 C-12.64393761 1.0137305 -6.70266639 0 0 0 Z ",
    fill: "#37C27A",
    transform: "translate(612,892)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8971875 0.5259375 0.8971875 0.5259375 1.8125 1.0625 C-4.0812268 5.77748144 -11.2609638 4.31881619 -18.3125 3.5625 C-19.59125 3.3975 -20.87 3.2325 -22.1875 3.0625 C-22.1875 2.7325 -22.1875 2.4025 -22.1875 2.0625 C-20.39892578 1.86333984 -20.39892578 1.86333984 -18.57421875 1.66015625 C-17.00779322 1.48194017 -15.44138802 1.30354544 -13.875 1.125 C-13.08931641 1.03798828 -12.30363281 0.95097656 -11.49414062 0.86132812 C-10.73681641 0.77431641 -9.97949219 0.68730469 -9.19921875 0.59765625 C-8.50272217 0.519104 -7.80622559 0.44055176 -7.08862305 0.35961914 C-1.27934442 -0.54829046 -1.27934442 -0.54829046 0 0 Z ",
    fill: "#1CAC78",
    transform: "translate(635.1875,329.9375)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65253306 2.47879959 2.58244128 4.31730933 3.5625 7.0625 C4.30051803 9.11594912 5.02350686 11.04701371 6 13 C6.36141955 15.32914823 6.69699525 17.66253478 7 20 C4.56385861 19.03863016 3.26540703 18.4684236 1.953125 16.15234375 C0.17834511 10.56178709 -0.27927094 5.86468983 0 0 Z ",
    fill: "#F6BA18",
    transform: "translate(508,572)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.26607607 0.53229326 -2.53810412 1.05044544 -3.8125 1.5625 C-4.52019531 1.85253906 -5.22789062 2.14257812 -5.95703125 2.44140625 C-8 3 -8 3 -11 2 C-13.20959253 1.84890907 -15.42300047 1.75126199 -17.63671875 1.68359375 C-19.58481445 1.62075195 -19.58481445 1.62075195 -21.57226562 1.55664062 C-22.94400761 1.51683013 -24.31575244 1.47711784 -25.6875 1.4375 C-27.07097645 1.39429165 -28.45444027 1.35067661 -29.83789062 1.30664062 C-33.22515719 1.20041972 -36.61249799 1.09837642 -40 1 C-40 0.67 -40 0.34 -40 0 C-34.78575406 -0.16763742 -29.57135652 -0.32819469 -24.35668945 -0.48217773 C-22.58254115 -0.53556608 -20.80845009 -0.59089298 -19.03442383 -0.64819336 C-16.48531435 -0.73019269 -13.93608072 -0.80523144 -11.38671875 -0.87890625 C-10.19594978 -0.91945885 -10.19594978 -0.91945885 -8.98112488 -0.96083069 C-5.69363284 -1.05004432 -3.14650219 -1.04883406 0 0 Z ",
    fill: "#0CA28E",
    transform: "translate(429,332)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.3125 4.0625 0.3125 4.0625 -1 7 C-1.42152344 8.10021484 -1.42152344 8.10021484 -1.8515625 9.22265625 C-4.375 15.53125 -4.375 15.53125 -7.75 18.0625 C-8.86375 18.5265625 -8.86375 18.5265625 -10 19 C-8.62394084 14.23448987 -6.53221934 10.2751447 -3.875 6.125 C-3.50246094 5.53203125 -3.12992188 4.9390625 -2.74609375 4.328125 C-1.83635 2.8818657 -0.91896202 1.44041954 0 0 Z ",
    fill: "#10B771",
    transform: "translate(659,239)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-0.94674033 7.12543646 -4.39468009 10.75610863 -9 13 C-9.99 12.67 -10.98 12.34 -12 12 C-8.04 8.04 -4.08 4.08 0 0 Z ",
    fill: "#36C279",
    transform: "translate(234,246)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8971875 0.309375 0.8971875 0.309375 1.8125 0.625 C-2.83607982 5.67202952 -6.50954254 7.48020729 -13.1875 8.625 C-12 5.6875 -12 5.6875 -10.1875 2.625 C-7.6875 1.875 -7.6875 1.875 -5.1875 1.625 C-2.1875 -0.375 -2.1875 -0.375 0 0 Z ",
    fill: "#3DC179",
    transform: "translate(291.1875,201.375)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.69141656 0.08963062 3.37959602 0.24577676 5.0625 0.4375 C6.44115234 0.59025391 6.44115234 0.59025391 7.84765625 0.74609375 C8.55792969 0.82988281 9.26820313 0.91367187 10 1 C10 1.66 10 2.32 10 3 C10.99 3.33 11.98 3.66 13 4 C12.67 4.66 12.34 5.32 12 6 C8.625 6.125 8.625 6.125 5 6 C4.34 5.34 3.68 4.68 3 4 C3.33 3.67 3.66 3.34 4 3 C3.01 2.67 2.02 2.34 1 2 C0.67 3.32 0.34 4.64 0 6 C-0.38218767 4.34385343 -0.71395102 2.67542976 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#48C382",
    transform: "translate(427,898)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.33333333 0 2.66666667 0 4 0 C3.67 2.31 3.34 4.62 3 7 C2.34 6.67 1.68 6.34 1 6 C0.73445312 6.62648438 0.46890625 7.25296875 0.1953125 7.8984375 C-0.15789063 8.71570313 -0.51109375 9.53296875 -0.875 10.375 C-1.22304688 11.18710937 -1.57109375 11.99921875 -1.9296875 12.8359375 C-3 15 -3 15 -5 17 C-4.28547412 12.23649415 -3.20465156 7.65798604 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#3EBE78",
    transform: "translate(721,304)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.92017937 7.82152466 1.92017937 7.82152466 -0.3359375 10.7109375 C-2 12.0625 -2 12.0625 -5 14 C-5.6796875 12.328125 -5.6796875 12.328125 -6 10 C-4.8203125 7.421875 -4.8203125 7.421875 -3.125 4.75 C-2.57070313 3.85796875 -2.01640625 2.9659375 -1.4453125 2.046875 C-0.96835937 1.37140625 -0.49140625 0.6959375 0 0 Z ",
    fill: "#10BC72",
    transform: "translate(671,218)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C0.02 3.99 0.02 3.99 -2 5 C-2 5.99 -2 6.98 -2 8 C-2.66 8 -3.32 8 -4 8 C-4.226875 8.66 -4.45375 9.32 -4.6875 10 C-6.40571358 13.92734533 -8.66774607 17.41260178 -11 21 C-11.66 20.67 -12.32 20.34 -13 20 C-11.58795618 17.60133582 -10.17057624 15.20610416 -8.75 12.8125 C-8.35425781 12.13896484 -7.95851563 11.46542969 -7.55078125 10.77148438 C-5.27113973 6.9409392 -2.89005068 3.41370665 0 0 Z ",
    fill: "#F4DA17",
    transform: "translate(323,412)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5.125 6.875 5.125 6.875 4 8 C3.95936168 9.66617115 3.957279 11.33388095 4 13 C2.42445965 10.11371599 1.53723627 7.46657616 0.875 4.25 C0.70742188 3.45078125 0.53984375 2.6515625 0.3671875 1.828125 C0.24601562 1.22484375 0.12484375 0.6215625 0 0 Z ",
    fill: "#5AC68E",
    transform: "translate(506,832)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-6.93873478 3.73353242 -13.20129894 6.70021649 -21 8 C-20.67 7.34 -20.34 6.68 -20 6 C-17.69289122 5.40103907 -15.38311282 5.04345035 -13.03125 4.66015625 C-12.02578125 4.33337891 -12.02578125 4.33337891 -11 4 C-10.67 3.01 -10.34 2.02 -10 1 C-8.22265625 0.234375 -8.22265625 0.234375 -6.0625 -0.25 C-5.35222656 -0.42015625 -4.64195312 -0.5903125 -3.91015625 -0.765625 C-2 -1 -2 -1 0 0 Z ",
    fill: "#F3DC1B",
    transform: "translate(604,746)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.06058594 1.02480469 1.12117188 2.04960938 1.18359375 3.10546875 C1.26805026 4.46615695 1.35269567 5.82683343 1.4375 7.1875 C1.47681641 7.86103516 1.51613281 8.53457031 1.55664062 9.22851562 C1.73807877 12.08965565 1.96796806 14.84873808 2.5625 17.65625 C3.06657449 20.35664904 2.88909158 22.59090348 2.5625 25.3125 C2.46066406 26.19550781 2.35882813 27.07851563 2.25390625 27.98828125 C2.12822266 28.98408203 2.12822266 28.98408203 2 30 C1.67 30 1.34 30 1 30 C0.68959988 26.04952215 0.38663072 22.09855222 0.09057617 18.14697266 C-0.01121539 16.80241488 -0.11504632 15.45800989 -0.22094727 14.11376953 C-0.37269911 12.18303014 -0.51654217 10.25167425 -0.66015625 8.3203125 C-0.74918213 7.15773926 -0.83820801 5.99516602 -0.92993164 4.79736328 C-1 2 -1 2 0 0 Z ",
    fill: "#68D097",
    transform: "translate(119,532)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.886875 3.144375 -1.77375 3.28875 -2.6875 3.4375 C-5.47117646 3.91019978 -8.23483757 4.43070185 -11 5 C-10.67 4.01 -10.34 3.02 -10 2 C-11.65 2 -13.3 2 -15 2 C-15 1.67 -15 1.34 -15 1 C-9.94997778 -0.03590199 -5.12583611 -0.10251672 0 0 Z ",
    fill: "#2FB664",
    transform: "translate(419,333)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.375 -0.1875 2.375 -0.1875 5 0 C5.66 0.99 6.32 1.98 7 3 C6.01 3 5.02 3 4 3 C3.71125 3.78375 3.4225 4.5675 3.125 5.375 C2 8 2 8 0 10 C-0.74926071 6.33694766 -1.2380014 3.57644848 0 0 Z ",
    fill: "#F1553A",
    transform: "translate(696,164)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.09522263 2.46573934 0.17565859 3.92235756 -0.75 5.375 C-1.26046875 6.18710937 -1.7709375 6.99921875 -2.296875 7.8359375 C-4.0917306 10.11655677 -5.37334079 10.88044034 -8 12 C-9.70921589 13.5412312 -9.70921589 13.5412312 -11 15 C-11.66 14.67 -12.32 14.34 -13 14 C-12.22914063 13.24074219 -11.45828125 12.48148438 -10.6640625 11.69921875 C-9.65090904 10.69544634 -8.63789552 9.69153268 -7.625 8.6875 C-7.11710938 8.18798828 -6.60921875 7.68847656 -6.0859375 7.17382812 C-3.77145867 4.87457613 -1.81652517 2.72478775 0 0 Z ",
    fill: "#F6BA15",
    transform: "translate(620,604)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.93230193 1.32120828 4.98664899 2.74638197 7.234375 5.0390625 C8.09482422 5.90917969 8.09482422 5.90917969 8.97265625 6.796875 C9.55917969 7.40015625 10.14570313 8.0034375 10.75 8.625 C11.35199219 9.23601563 11.95398438 9.84703125 12.57421875 10.4765625 C14.05405305 11.97988624 15.52764676 13.48934856 17 15 C14 15 14 15 11.40625 12.6640625 C10.42985797 11.65840531 9.46137299 10.64502439 8.5 9.625 C5.79386716 6.79683995 3.28035415 4.18690277 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#107156",
    transform: "translate(299,703)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.65066406 1.44730469 1.30132813 1.89460938 0.94140625 2.35546875 C-2.02928477 6.23673889 -2.02928477 6.23673889 -3.5625 10.8125 C-3.706875 11.534375 -3.85125 12.25625 -4 13 C-6.0625 14.3125 -6.0625 14.3125 -8 15 C-6.70258059 10.10972685 -5.26746317 5.53492633 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#1DAE69",
    transform: "translate(651,256)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.07094823 -0.10466648 15.9874678 -0.03387512 24 1 C24 1.33 24 1.66 24 2 C15.64731722 3.2386744 8.27086157 2.59105604 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#16B864",
    transform: "translate(443,901)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.98 0 3.96 0 6 C-2.97 5.67 -5.94 5.34 -9 5 C-2.87096774 0 -2.87096774 0 0 0 Z ",
    fill: "#107658",
    transform: "translate(612,768)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.67 3.99 2.34 4.98 2 6 C2.88319294 9.15020361 2.88319294 9.15020361 4 12 C3.01 12.33 2.02 12.66 1 13 C-2 4 -2 4 -1.0625 1.8125 C-0.5365625 0.9153125 -0.5365625 0.9153125 0 0 Z M0 2 C1 4 1 4 1 4 Z ",
    fill: "#44C481",
    transform: "translate(869,357)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.41176754 3.60296594 1.1535853 4.78402067 -1 7.8125 C-1.66 8.534375 -2.32 9.25625 -3 10 C-4.32 9.67 -5.64 9.34 -7 9 C-5.85793642 7.49712782 -4.71125043 5.99776716 -3.5625 4.5 C-2.92441406 3.6646875 -2.28632813 2.829375 -1.62890625 1.96875 C-0.82259766 0.99421875 -0.82259766 0.99421875 0 0 Z ",
    fill: "#3AC279",
    transform: "translate(202,281)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.79379098 0.44994757 3.58498928 0.91024143 5.375 1.375 C6.37273437 1.63023437 7.37046875 1.88546875 8.3984375 2.1484375 C11 3 11 3 13 5 C12.01 5.66 11.02 6.32 10 7 C10 6.34 10 5.68 10 5 C8.6696875 4.814375 8.6696875 4.814375 7.3125 4.625 C4.29612498 4.05587264 1.79673946 3.23385564 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#45C380",
    transform: "translate(370,881)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.37321829 3.66172475 0.35548154 6.8818995 -1.0625 10.3125 C-1.42472656 11.19550781 -1.78695312 12.07851563 -2.16015625 12.98828125 C-2.43730469 13.65214844 -2.71445312 14.31601562 -3 15 C-3.33 15 -3.66 15 -4 15 C-3.50341703 9.33895411 -2.45489316 5.12325529 0 0 Z ",
    fill: "#3DC37B",
    transform: "translate(876,640)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.36929236 4.73858473 -2.47346048 5.42154861 -5.078125 6.84765625 C-8.00205876 8.60082791 -10.44124163 10.75328534 -13 13 C-11.50536684 9.3852622 -9.4391696 7.35564512 -6.5 4.8125 C-5.7059375 4.11769531 -4.911875 3.42289062 -4.09375 2.70703125 C-2 1 -2 1 0 0 Z ",
    fill: "#FDFCF1",
    transform: "translate(540,451)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.10191901 4.40767604 0.58706842 5.8922935 -1 10 C-1.33 10 -1.66 10 -2 10 C-2 8.35 -2 6.7 -2 5 C-3.98 6.32 -5.96 7.64 -8 9 C-8.66 8.67 -9.32 8.34 -10 8 C-6.7 5.36 -3.4 2.72 0 0 Z ",
    fill: "#0D6D54",
    transform: "translate(279,347)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 0 6 C5.61 6 11.22 6 17 6 C17 6.33 17 6.66 17 7 C7.595 7.495 7.595 7.495 -2 8 C-1.34 5.36 -0.68 2.72 0 0 Z ",
    fill: "#D41C24",
    transform: "translate(391,272)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -2.40625 5.48046875 C-3.43005231 6.39125392 -4.46167034 7.29331192 -5.5 8.1875 C-6.02464844 8.65091797 -6.54929687 9.11433594 -7.08984375 9.59179688 C-8.38666224 10.735355 -9.69249867 11.86867174 -11 13 C-11.66 12.67 -12.32 12.34 -13 12 C-8.91216216 6.42567568 -8.91216216 6.42567568 -6.125 5.125 C-3.59843593 3.78740726 -1.94073664 2.07936068 0 0 Z ",
    fill: "#2AB565",
    transform: "translate(669,703)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.47157735 3.43927719 7.44583985 8.3047663 10 14 C9.34 14.66 8.68 15.32 8 16 C7.67 14.35 7.34 12.7 7 11 C6.34 11 5.68 11 5 11 C4.54625 9.9275 4.0925 8.855 3.625 7.75 C2.49911463 5.11937683 1.32079794 2.53999604 0 0 Z ",
    fill: "#FCFBEC",
    transform: "translate(483,525)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.56919192 2.25886817 3.68000131 4.20020805 4.75 7.4375 C5.01296875 8.19933594 5.2759375 8.96117187 5.546875 9.74609375 C6.04123949 12.20513089 5.79335904 13.64672554 5 16 C4.15787744 14.08717875 3.32661136 12.16957527 2.5 10.25 C2.0359375 9.18265625 1.571875 8.1153125 1.09375 7.015625 C0 4 0 4 0 0 Z ",
    fill: "#F3DD17",
    transform: "translate(720,460)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.52164009 -0.18451025 11.52164009 -0.18451025 17 1 C17 1.99 17 2.98 17 4 C16.01 4 15.02 4 14 4 C14 3.34 14 2.68 14 2 C13.11248047 2.01740234 13.11248047 2.01740234 12.20703125 2.03515625 C7.99768215 2.08322386 4.1077667 2.06006883 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#19B560",
    transform: "translate(691,332)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.33 4.62 0.66 7 1 C3.25474201 4.74525799 -0.98270909 4.68909949 -6 5 C-5.67 4.01 -5.34 3.02 -5 2 C-3.35 1.67 -1.7 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#38C176",
    transform: "translate(446,804)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C4.34 5.63 3.68 9.26 3 13 C2.67 13 2.34 13 2 13 C1.66127487 11.58461283 1.32925376 10.16762037 1 8.75 C0.814375 7.96109375 0.62875 7.1721875 0.4375 6.359375 C0 4 0 4 0 0 Z M2 3 C2.33 3.66 2.66 4.32 3 5 C3.33 4.34 3.66 3.68 4 3 C3.34 3 2.68 3 2 3 Z ",
    fill: "#53C588",
    transform: "translate(721,347)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.6875 3.0625 3.6875 3.0625 4 5 C4.66 5 5.32 5 6 5 C5.67 6.65 5.34 8.3 5 10 C4.67 9.34 4.34 8.68 4 8 C1.97536745 7.34786708 1.97536745 7.34786708 0 7 C0.33 6.01 0.66 5.02 1 4 C0.61067144 1.85744207 0.61067144 1.85744207 0 0 Z ",
    fill: "#44C37F",
    transform: "translate(154,680)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0.66 7.26 1.32 11 2 C6.01222852 4.49388574 4.33016752 3.88836125 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#EF6749",
    transform: "translate(665,153)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C4.1875 4.0625 4.1875 4.0625 5 7 C5.66 7 6.32 7 7 7 C7 7.66 7 8.32 7 9 C6.01 9.33 5.02 9.66 4 10 C1 4.25 1 4.25 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#41C17B",
    transform: "translate(149,670)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.99 3.63 3.98 7.26 5 11 C4.34 11.66 3.68 12.32 3 13 C2.49487756 11.39743892 1.99608373 9.79288208 1.5 8.1875 C1.2215625 7.29417969 0.943125 6.40085937 0.65625 5.48046875 C0 3 0 3 0 0 Z ",
    fill: "#43C07B",
    transform: "translate(134,627)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.54971796 0.60852308 6.76693609 1.38346804 10 3 C10.33 3.99 10.66 4.98 11 6 C9.5410574 5.52269162 8.08286504 5.04308958 6.625 4.5625 C5.81289063 4.29566406 5.00078125 4.02882813 4.1640625 3.75390625 C2 3 2 3 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#43C280",
    transform: "translate(353,874)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 1.66 3 2.32 3 3 C3.804375 3.37125 3.804375 3.37125 4.625 3.75 C7.56424252 5.29696975 10.25754408 7.13014369 13 9 C12.01 9.495 12.01 9.495 11 10 C8.5249829 8.88568235 6.32116581 7.41849022 4 6 C4 5.34 4 4.68 4 4 C2.68 3.34 1.36 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FDFAE8",
    transform: "translate(530,611)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.13277344 0.71027344 1.26554687 1.42054688 1.40234375 2.15234375 C1.57894531 3.07144531 1.75554687 3.99054687 1.9375 4.9375 C2.11152344 5.85402344 2.28554688 6.77054688 2.46484375 7.71484375 C2.77714988 9.95289844 2.77714988 9.95289844 4 11 C4.04063832 12.66617115 4.042721 14.33388095 4 16 C3.67 15.01 3.34 14.02 3 13 C2.34 13 1.68 13 1 13 C0.1276588 10.00519083 -0.10829766 7.36424089 -0.0625 4.25 C-0.05347656 3.45078125 -0.04445313 2.6515625 -0.03515625 1.828125 C-0.02355469 1.22484375 -0.01195312 0.6215625 0 0 Z ",
    fill: "#F9BC19",
    transform: "translate(504,555)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.49415272 0.99766109 3.78740335 1.68616685 5.3125 3.9375 C6 6 6 6 5 9 C4.67 7.68 4.34 6.36 4 5 C2.02 5.99 2.02 5.99 0 7 C-0.38133299 5.0085944 -0.71325582 3.00720923 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#13B66D",
    transform: "translate(352,225)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.88637738 1.4800841 1.75877092 2.95910074 1.625 4.4375 C1.55539062 5.26121094 1.48578125 6.08492187 1.4140625 6.93359375 C1.27742187 7.61550781 1.14078125 8.29742187 1 9 C0.01 9.495 0.01 9.495 -1 10 C-1.66 9.34 -2.32 8.68 -3 8 C-2.60495559 5.0371669 -1.40182371 2.61673759 0 0 Z ",
    fill: "#11BC78",
    transform: "translate(687,189)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.3921875 0.2784375 1.3921875 0.2784375 2.8125 0.5625 C3.534375 0.706875 4.25625 0.85125 5 1 C5 1.33 5 1.66 5 2 C-0.45769811 2.11138159 -5.61509359 1.91657981 -11 1 C-11 0.67 -11 0.34 -11 0 C-6.94769975 -0.84815587 -4.00600959 -1.02718195 0 0 Z ",
    fill: "#60CB93",
    transform: "translate(467,904)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.25 2.4375 5.25 2.4375 4 5 C1.875 5.8125 1.875 5.8125 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#3AC77E",
    transform: "translate(688,856)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.11666174 3.34998521 -1.74694925 3.79340222 -4.5625 5.6875 C-5.20316406 6.12449219 -5.84382812 6.56148437 -6.50390625 7.01171875 C-6.99761719 7.33785156 -7.49132812 7.66398438 -8 8 C-8.66 7.67 -9.32 7.34 -10 7 C-3.18421053 0 -3.18421053 0 0 0 Z ",
    fill: "#3EC37A",
    transform: "translate(725,838)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C2.66 3.67 3.32 3.34 4 3 C3.67 5.31 3.34 7.62 3 10 C2.01 10 1.02 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#38C57D",
    transform: "translate(888,422)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 1.66 3 2.32 3 3 C0.02588876 4.23921302 -2.85262818 5.30058404 -6 6 C-6.33 5.01 -6.66 4.02 -7 3 C-3.535 2.505 -3.535 2.505 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EF7354",
    transform: "translate(349,152)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.598125 0.185625 1.19625 0.37125 1.8125 0.5625 C4.16408762 1.22093687 4.16408762 1.22093687 7 0 C7.99 0.66 8.98 1.32 10 2 C0.58997722 4.29612756 0.58997722 4.29612756 -4 4 C-2.68 3.67 -1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#56CA8F",
    transform: "translate(578,898)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.97470651 3.05058698 0.77885154 4.76774402 -0.5625 6.625 C-1.01753906 7.25664063 -1.47257812 7.88828125 -1.94140625 8.5390625 C-2.29074219 9.02117188 -2.64007813 9.50328125 -3 10 C-4 7 -4 7 -3.22265625 5.17578125 C-2.1484375 3.45052083 -1.07421875 1.72526042 0 0 Z ",
    fill: "#35BB72",
    transform: "translate(506,800)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-2.95 5.475 -2.95 5.475 -8 8 C-8.33 7.34 -8.66 6.68 -9 6 C-6.03 4.02 -3.06 2.04 0 0 Z ",
    fill: "#1BA77C",
    transform: "translate(637,727)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.25 7.75 2.25 7.75 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#33C477",
    transform: "translate(856,680)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.5078125 1.75 3.5078125 1.75 5.125 4 C5.66382813 4.7425 6.20265625 5.485 6.7578125 6.25 C7.16773438 6.8275 7.57765625 7.405 8 8 C7.67 8.66 7.34 9.32 7 10 C5.35 8.02 3.7 6.04 2 4 C1.01 4.33 0.02 4.66 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#25CC72",
    transform: "translate(240,426)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.32 2.31 4.64 4.62 6 7 C3.0625 6.25 3.0625 6.25 0 5 C-0.9375 2.9375 -0.9375 2.9375 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#3FC27D",
    transform: "translate(285,833)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.1755306 2.1755306 2.71879553 3.55973892 3.6875 6.4375 C3.95949219 7.21996094 4.23148437 8.00242187 4.51171875 8.80859375 C5 11 5 11 4 14 C3.35242375 12.56328432 2.70700547 11.12559584 2.0625 9.6875 C1.70285156 8.88699219 1.34320313 8.08648438 0.97265625 7.26171875 C0 5 0 5 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#25B562",
    transform: "translate(289,610)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.05447047 1.41623216 1.09300508 2.83308191 1.125 4.25 C1.14820313 5.03890625 1.17140625 5.8278125 1.1953125 6.640625 C0.9828378 9.20731941 0.28654105 10.7916067 -1 13 C-2.20577428 8.05632546 -1.6290678 4.79137588 0 0 Z ",
    fill: "#35C175",
    transform: "translate(891,587)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 3.63 1.66 7.26 2 11 C1.01 11.33 0.02 11.66 -1 12 C-1.14285714 3.42857143 -1.14285714 3.42857143 0 0 Z ",
    fill: "#2DB566",
    transform: "translate(281,504)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0326802 2.78823655 1.04509293 3.8677274 0.0625 6.75 C-0.288125 7.4925 -0.63875 8.235 -1 9 C-1.66 9 -2.32 9 -3 9 C-3.33 9.66 -3.66 10.32 -4 11 C-3.67 8.69 -3.34 6.38 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#4DC585",
    transform: "translate(155,355)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C0.68 5.31 -0.64 7.62 -2 10 C-2.66 10 -3.32 10 -4 10 C-3.67 8.02 -3.34 6.04 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#43C27F",
    transform: "translate(163,339)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.65 6.33 -2.3 6.66 -4 7 C-2.92598892 4.08482708 -2.22189824 2.22189824 0 0 Z ",
    fill: "#3CC47E",
    transform: "translate(190,297)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.66 2.64 6.32 5.28 7 8 C4.35247996 5.42215154 2.05567935 3.08351902 0 0 Z ",
    fill: "#47C581",
    transform: "translate(205,761)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.02611949 1.65071396 4.02308143 3.31970006 5 5 C6.58245275 6.75149165 6.58245275 6.75149165 8 8 C2.25 6.375 2.25 6.375 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#21B166",
    transform: "translate(257,696)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5654594 2.5654594 2.54046087 4.47686668 3 8 C1.0625 7.6875 1.0625 7.6875 -1 7 C-2 4 -2 4 -1.0625 1.8125 C-0.5365625 0.9153125 -0.5365625 0.9153125 0 0 Z ",
    fill: "#70CD96",
    transform: "translate(138,641)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.37503669 1.1858237 5.64722731 2.27573689 8 5 C5.69 4.67 3.38 4.34 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#3FC37C",
    transform: "translate(724,196)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.33 -1.98 0.66 -3 1 C-3.33 1.66 -3.66 2.32 -4 3 C-5.98 3 -7.96 3 -10 3 C-10 2.34 -10 1.68 -10 1 C-6.78548731 -0.60725635 -3.56387464 -0.05748185 0 0 Z ",
    fill: "#50C788",
    transform: "translate(623,890)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 2.32 2 3.64 2 5 C1.34 5 0.68 5 0 5 C-0.33 5.66 -0.66 6.32 -1 7 C-1.66 5.35 -2.32 3.7 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#EB6E4C",
    transform: "translate(325,163)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.625 0.75 6.625 0.75 10 3 C6.71303767 3.79953138 5.28976808 4.09658936 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#EF7459",
    transform: "translate(676,156)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.66 -0.66 1.32 -1 2 C-4.375 2.125 -4.375 2.125 -8 2 C-8.66 1.34 -9.32 0.68 -10 0 C-6.33694766 -0.74926071 -3.57644848 -1.2380014 0 0 Z ",
    fill: "#69CB94",
    transform: "translate(440,902)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.1875 1.9375 5.1875 1.9375 4 4 C3.01 4.33 2.02 4.66 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#48C17D",
    transform: "translate(507,832)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.33 0.99 3.66 1.98 4 3 C2.68 4.32 1.36 5.64 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#37C47A",
    transform: "translate(808,755)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.33333333 0 4.66666667 0 7 C-0.99 7.495 -0.99 7.495 -2 8 C-2.33 6.02 -2.66 4.04 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#40C581",
    transform: "translate(819,743)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-7.42857143 2.28571429 -7.42857143 2.28571429 -11 0 C-7.01803543 -1.05404945 -4.01804691 -0.84098656 0 0 Z ",
    fill: "#1BB365",
    transform: "translate(246,706)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.5625 1.8125 1.5625 1.8125 3 4 C2.67 4.99 2.34 5.98 2 7 C1.01 6.67 0.02 6.34 -1 6 C-1.33 5.01 -1.66 4.02 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#3BC57B",
    transform: "translate(858,338)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.35277269 3.72426311 -2.62496331 4.8141763 -6 6 C-6.33 5.34 -6.66 4.68 -7 4 C-1.7265625 0.77734375 -1.7265625 0.77734375 0 0 Z ",
    fill: "#44BF79",
    transform: "translate(312,187)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.99 6 1.98 6 3 C4.02 3.33 2.04 3.66 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#62C98F",
    transform: "translate(304,851)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 1.65 3.3 3.3 5 5 C4.34 5.66 3.68 6.32 3 7 C1.68 6.01 0.36 5.02 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#52C182",
    transform: "translate(433,793)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.1875 1.5625 -1.1875 1.5625 -3 3 C-5.625 2.8125 -5.625 2.8125 -8 2 C-8.33 1.34 -8.66 0.68 -9 0 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#ECCE2B",
    transform: "translate(548,762)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.75 2.875 2.75 2.875 2 5 C-0.0625 6.25 -0.0625 6.25 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#3FC47E",
    transform: "translate(141,388)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C-0.97180943 3.89865603 -3.51460083 5.35455571 -7 6 C-4.74259377 3.66475218 -2.7194239 1.81294927 0 0 Z ",
    fill: "#F1D41B",
    transform: "translate(381,355)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 0 2 0 3.5625 1.1875 C5.32681541 3.4120716 5.62403791 5.21788056 6 8 C5.01 8.495 5.01 8.495 4 9 C2.68 6.03 1.36 3.06 0 0 Z ",
    fill: "#E65F3A",
    transform: "translate(361,237)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.60031344 3.20062687 0.03173691 5.72271806 -1 9 C-1.33 9 -1.66 9 -2 9 C-2.66 6.69 -3.32 4.38 -4 2 C-2.68 1.34 -1.36 0.68 0 0 Z ",
    fill: "#E15B38",
    transform: "translate(678,200)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.01 3 1.02 3 0 3 C-0.66 4.32 -1.32 5.64 -2 7 C-2.33 5.02 -2.66 3.04 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#D87B58",
    transform: "translate(700,164)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C0.68 4 -0.64 4 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#61C98B",
    transform: "translate(146,667)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#63C88E",
    transform: "translate(320,861)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 4 0.68 4 0 4 C-0.33 3.01 -0.66 2.02 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#5CC88A",
    transform: "translate(171,715)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#46BB7A",
    transform: "translate(256,701)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2 1.99 2 2.98 2 4 C1.34 3.67 0.68 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#5ACA8A",
    transform: "translate(184,297)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.33 0.66 5.66 1.32 6 2 C3.03 1.505 3.03 1.505 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#D78B67",
    transform: "translate(694,160)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#EC6746",
    transform: "translate(569,136)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C1.68 2.33 0.36 2.66 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#61C98E",
    transform: "translate(354,877)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.68 1.33 0.36 1.66 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#62CA8E",
    transform: "translate(537,908)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.68 1.67 1.36 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#63C78D",
    transform: "translate(375,886)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#62C98E",
    transform: "translate(884,395)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.99 2 1.98 2 3 C1.34 2.67 0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5BC788",
    transform: "translate(153,352)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.01 3.495 1.01 3.495 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#4DC17D",
    transform: "translate(728,336)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#58C588",
    transform: "translate(192,288)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 1 1.68 1 1 1 C0.67 1.66 0.34 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#56C987",
    transform: "translate(248,229)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E96042",
    transform: "translate(563,136)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C0.68 1.67 -0.64 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#ED6042",
    transform: "translate(508,133)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#EC6043",
    transform: "translate(489,134)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#61C98D",
    transform: "translate(579,902)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#64C78E",
    transform: "translate(336,869)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#5FCA8D",
    transform: "translate(739,830)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 1.67 0.02 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#47C07B",
    transform: "translate(442,804)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#61CA8F",
    transform: "translate(821,748)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#63C88B",
    transform: "translate(176,725)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#47BF7E",
    transform: "translate(253,711)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#47B97A",
    transform: "translate(246,703)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#61CA8D",
    transform: "translate(138,653)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#5DC288",
    transform: "translate(895,582)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#61C48A",
    transform: "translate(120,464)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4DC27E",
    transform: "translate(738,330)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#4ABC7B",
    transform: "translate(719,318)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#5BC88A",
    transform: "translate(813,268)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#C1996D",
    transform: "translate(321,167)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#E48362",
    transform: "translate(344,152)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#ED7756",
    transform: "translate(379,144)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#EE6244",
    transform: "translate(522,134)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#62CC8E",
    transform: "translate(483,910)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#5FC88E",
    transform: "translate(512,909)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#61CA8F",
    transform: "translate(495,909)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#5FC98D",
    transform: "translate(585,901)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#5FC78D",
    transform: "translate(613,894)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#65CC90",
    transform: "translate(369,884)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#65C68E",
    transform: "translate(323,862)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#62C28B",
    transform: "translate(297,846)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5BC588",
    transform: "translate(274,829)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4DC17E",
    transform: "translate(520,818)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48C17B",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#47BF7C",
    transform: "translate(419,805)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#49BE7C",
    transform: "translate(432,799)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5CC688",
    transform: "translate(235,796)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5DC587",
    transform: "translate(121,584)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C988",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8D",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C88F",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5FC58A",
    transform: "translate(894,432)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#61CA8C",
    transform: "translate(129,419)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5BCA89",
    transform: "translate(874,368)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#58C786",
    transform: "translate(160,339)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4EC27F",
    transform: "translate(709,332)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ACB8B",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5CC88A",
    transform: "translate(171,320)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5CC48B",
    transform: "translate(814,271)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#57C885",
    transform: "translate(211,265)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#58C987",
    transform: "translate(232,245)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#59C989",
    transform: "translate(232,243)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#56C786",
    transform: "translate(236,241)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5AC689",
    transform: "translate(255,224)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5EC48B",
    transform: "translate(758,217)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C489",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C68D",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9369",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#E18766",
    transform: "translate(339,153)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#E18968",
    transform: "translate(341,153)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#ED5F42",
    transform: "translate(514,134)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#EC6043",
    transform: "translate(498,134)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5DC88D",
    transform: "translate(499,910)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#61CB8E",
    transform: "translate(480,909)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#63CA8F",
    transform: "translate(418,899)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#60C98D",
    transform: "translate(611,895)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#61CB8E",
    transform: "translate(397,895)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#60C88F",
    transform: "translate(617,893)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C891",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#60C88D",
    transform: "translate(357,879)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#60C68C",
    transform: "translate(672,871)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#65C58B",
    transform: "translate(325,863)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC68D",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4DC282",
    transform: "translate(525,818)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5FBB8B",
    transform: "translate(766,807)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CCA8A",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC889",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCA8C",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC18A",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#62CB8D",
    transform: "translate(208,773)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC889",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC58A",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8E",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC188",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#45BD7C",
    transform: "translate(260,706)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA8D",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C68B",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C18C",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CB8D",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C587",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8F",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC688",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC889",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC78C",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66CC8E",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C891",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66CD91",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CD8F",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C98C",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8D",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8F",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC88A",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4CBF7D",
    transform: "translate(707,330)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC78A",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ACB8A",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#48BF79",
    transform: "translate(730,323)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC689",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C688",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C987",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C889",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5AC88B",
    transform: "translate(828,289)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5ECC8B",
    transform: "translate(200,272)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC887",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#58C988",
    transform: "translate(797,252)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5DC98D",
    transform: "translate(229,248)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC88A",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5EC087",
    transform: "translate(766,224)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98C",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#EC7E5E",
    transform: "translate(367,147)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#EE6D4B",
    transform: "translate(584,137)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#ED6547",
    transform: "translate(532,134)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69CE95",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88B",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88F",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CB8D",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C98D",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88D",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC98B",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CC8F",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8F",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CC91",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98C",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CC91",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA8E",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC78C",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8E",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C188",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C98F",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CB91",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CA90",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB90",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CB8F",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88B",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA90",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCA8D",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CC92",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8E",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8F",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CC789",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC68B",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CB8F",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C78F",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C68B",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98D",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CE90",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C38A",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CA90",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6ACB90",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C890",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#67CB90",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66CD91",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#67C38C",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69C991",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CB8D",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C58A",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6BCB92",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECB8B",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69CB91",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C98E",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA90",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CB90",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC588",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB92",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C68D",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC88B",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C58E",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC98F",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC98F",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C98D",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98E",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C88D",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C58F",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CB90",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88A",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98D",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CB92",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA8E",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C58C",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CA8D",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C68A",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CC38B",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC68E",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C78D",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49BE7D",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC48C",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49C17C",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#54C18B",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CC47E",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47BD7D",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44B678",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48C17D",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47C27B",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CC17E",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB91",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C68B",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46BF7D",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CB8F",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47C07A",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4BBE7C",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FCA8F",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48C17C",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CBE7E",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4DBD7E",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48C079",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CB8D",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4ABF7B",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48C07B",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48BE7B",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4BBE7A",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC68E",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47C07B",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC68C",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECC8E",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48BE7C",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62BD8B",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC78D",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECE8E",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC88B",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C98C",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58BD87",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCB8C",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C989",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C88D",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C789",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCB8A",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C787",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC68C",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC78D",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC58A",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC88D",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C98D",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC788",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC689",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC28E",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CC8D",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66C690",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC98D",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98C",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC68A",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C28F",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47BF7E",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43BD79",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CC8F",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C78D",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C98B",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98A",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C78E",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CA90",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C88C",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC588",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC08D",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC58A",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C88B",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA8D",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98D",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CA8D",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C78A",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C68C",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C487",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66C98E",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB8D",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CC8F",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8B",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CA8A",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8C",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA8D",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA8D",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C98F",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#67CB8E",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CA8D",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C78D",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C88F",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C68C",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C68E",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC887",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C889",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB8F",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CB8D",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CC8E",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CA8D",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98C",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C58A",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CA90",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC886",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC789",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CA8B",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC887",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CD90",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CB90",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63CA90",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CA8B",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C88A",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CA8E",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66CA8E",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98F",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65CC8E",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC689",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C98F",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC483",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62CB8D",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66CA90",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C791",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C183",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C78A",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64CD8D",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCA8C",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62C98E",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CC8C",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CC90",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C98A",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98B",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCA89",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FCC8E",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C98F",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EBF86",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCA88",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA8B",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FCA8A",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CA8E",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC98A",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56C584",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CC90",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC68B",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC888",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC88F",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC88D",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C488",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C78B",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60CB8F",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CC78C",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4DC47E",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4AC57D",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCB90",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CCA8C",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4EC17E",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44BC75",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4AC67F",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CC27C",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4AC27F",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CC37E",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4CC17F",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4BC07F",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC98D",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47C07A",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5EC98B",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4AC07B",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47C07A",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB8A",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCB8F",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56C78A",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56C586",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC98E",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC687",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC98C",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4DBE7B",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CCC8C",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CCD8E",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C389",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCB8F",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA91",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C88E",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C788",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C489",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#52C786",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC68C",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC889",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC78A",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#55C783",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC789",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C689",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC181",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA8E",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61CB8B",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58CA89",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#55C888",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56C986",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ACC89",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB88",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCE8A",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC888",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCD8B",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56CB87",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C88A",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C988",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC989",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCB89",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB89",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCA89",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C988",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC786",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ACC8B",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C687",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C788",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C88D",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC688",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C686",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC98A",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB8A",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53CB83",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC689",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57CD89",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53C887",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5AC98B",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#52C787",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BCB8A",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CCA8A",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58C88A",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB88",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57C988",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ECA8C",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59CB89",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5ACA8A",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59C889",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC88A",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DCB89",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5BC188",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC58A",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5DC78A",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5CC485",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C387",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#63C387",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C287",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61C689",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60C483",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC585",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5FC689",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#64C688",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69C88A",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65C789",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61BF87",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66C088",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6BC082",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65BF7D",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7FBA84",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#78B57D",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7BAF7C",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#84AE78",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A06F",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A472",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA075",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19B72",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE976D",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59A6E",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE9E6F",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D2996F",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE9670",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E28561",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB916C",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E77F5C",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E48D6A",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF8965",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E68060",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E67F5E",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E07659",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E27759",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E08F69",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E97355",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB6D4F",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E97B5C",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA8363",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA7959",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC7656",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA7858",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E97454",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E97C5B",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA7657",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA7554",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB6F51",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC7959",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB7455",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC7657",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF6A49",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF6F50",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC7454",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC7557",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC6E4E",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED6A4A",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED6745",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB6E4F",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED704F",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC6C4B",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB7054",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF6447",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC6343",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EE6142",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC6347",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB6346",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED6347",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ED6348",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB6447",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50Meeting);
export default __webpack_public_path__ + "static/media/50-meeting.7cf19055735d5fd806db0da0b2e28ae2.svg";
export { ForwardRef as ReactComponent };